<template>
  <div>
    <svg
      v-if="props.icon == 'check'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15.4 11.9"
      fill="currentColor"
      width="20"
      height="20"
    >
      <path
        d="M12.6.1L6 6.8 2.8 3.6c-.2-.2-.4-.2-.6 0L.1 5.7c-.1.1-.1.4 0 .5l5.6 5.6c.2.2.4.2.6 0l9-9c.2-.2.2-.4 0-.6L13.2.1c-.2-.1-.4-.1-.6 0z"
      />
    </svg>

    <svg
      v-if="props.icon == 'briefcase'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 95.4 96.9"
      fill="currentColor"
      width="20"
      height="20"
    >
      <path
        d="M0 17.9v61.6c0 1.6 1.3 2.9 2.9 2.9H15V15H2.9C1.3 15 0 16.3 0 17.9zM94.2 15h-12v67.4h12.1c1.6 0 2.9-1.3 2.9-2.9V17.9c-.1-1.6-1.4-2.9-3-2.9zM66.3 3.7c0-2.1-1.7-3.7-3.7-3.7H34.5c-2.1 0-3.7 1.7-3.7 3.7V15H19.6v67.4h58V15H66.3V3.7zM38.3 15V7.5h20.6V15H38.3z"
      />
    </svg>
    <svg
      v-if="props.icon == 'star'"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 124.5 118.8"
      width="20"
      height="20"
      fill="currentColor"
    >
      <path
        d="M65.9 2.3L82.8 37l38.2 5.3c3.3.5 4.7 4.6 2.2 6.9L95.4 76l6.8 38c.6 3.3-2.9 5.9-5.9 4.3l-34.1-18.2-34.1 18.2c-3 1.6-6.5-1-5.9-4.3L29 76 1.2 49.2c-2.4-2.3-1.1-6.5 2.2-6.9L41.7 37 58.6 2.3c1.5-3.1 5.8-3.1 7.3 0z"
      />
    </svg>
    <svg
      v-if="props.icon == 'ribbon2'"
      viewBox="0 0 78.4 88.8"
      width="20"
      height="20"
      fill="currentColor"
    >
      <path
        d="M51.9 39.2c0 7-5.7 12.7-12.7 12.7-7 0-12.7-5.7-12.7-12.7s5.7-12.7 12.7-12.7c7 0 12.7 5.7 12.7 12.7zM64.6 69l8.1 13.1L62 88.8l-8.2-13.2c-4.5 1.8-9.4 2.8-14.6 2.8s-10.1-1-14.6-2.8l-8.2 13.2-10.8-6.7L13.8 69C5.3 61.8 0 51.2 0 39.2 0 17.6 17.6 0 39.2 0c21.7 0 39.2 17.6 39.2 39.2 0 12-5.3 22.6-13.8 29.8zm-25.4-6.4c12.9 0 23.4-10.5 23.4-23.4S52.2 15.8 39.2 15.8 15.8 26.3 15.8 39.2s10.5 23.4 23.4 23.4z"
      />
    </svg>
    <svg
      v-if="props.icon == 'language'"
      viewBox="0 0 19.6 16.5"
      width="20"
      height="20"
      fill="currentColor"
    >
      <path d="M4.7 0H7v4.2H4.7z" />
      <path
        d="M11.6 2.9H0v1.8l.5.5 3.7 3.7-2.6 2.6L3.3 13l2.6-2.6 3.9 3.9.7-2.5-3-3 4.2-4.2V2.9zM5.8 7.2l-2-2h4.1l-2.1 2z"
      />
      <path
        d="M16.8 16.5c-.1-.4-.3-.8-.4-1.3-.2-.4-.3-.9-.5-1.3h-4.6c-.1.4-.3.9-.4 1.3-.2.4-.3.9-.4 1.3H7.6c.4-1.3.9-2.5 1.3-3.5.4-1.1.8-2.1 1.2-3.1s.8-1.9 1.1-2.7c.4-.9.8-1.7 1.2-2.5h2.5c.4.8.8 1.7 1.1 2.5.4.9.8 1.8 1.1 2.7.4 1 .8 2 1.2 3.1.4 1.1.8 2.3 1.3 3.5h-2.8zm-3.3-9.2c-.1.2-.1.4-.3.7s-.2.7-.3 1c-.1.4-.3.8-.5 1.3l-.6 1.5h3.4c-.2-.5-.4-1-.5-1.5-.2-.5-.3-.9-.5-1.3s-.3-.7-.4-1c-.1-.3-.2-.5-.3-.7z"
      />
    </svg>
    <svg
      v-if="props.icon == 'house_small'"
      viewBox="0 0 20.2 20.2"
      width="20"
      height="20"
      fill="currentColor"
    >
      <path
        d="M0 6.1L10.1 0l10.1 6.1v2H0v-2zm0 12.1h20.2v2H0v-2zm2-2h16.2v2H2v-2zm0-8.1h3v8.1H2V8.1zm6.1 0h4v8.1h-4V8.1zm7.1 0h3v8.1h-3V8.1z"
      />
    </svg>
    <svg
      v-if="props.icon == 'clew'"
      viewBox="0 0 24 24"
      width="20"
      height="20"
      fill="currentColor"
    >
      <path
        opacity="0.3"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        fill="currentColor"
      ></path>
      <path
        d="M8.70001 6C8.10001 5.7 7.39999 5.40001 6.79999 5.10001C7.79999 4.00001 8.90001 3 10.1 2.2C10.7 2.1 11.4 2 12 2C12.7 2 13.3 2.1 13.9 2.2C12 3.2 10.2 4.5 8.70001 6ZM12 8.39999C13.9 6.59999 16.2 5.30001 18.7 4.60001C18.1 4.00001 17.4 3.6 16.7 3.2C14.4 4.1 12.2 5.40001 10.5 7.10001C11 7.50001 11.5 7.89999 12 8.39999ZM7 20C7 20.2 7 20.4 7 20.6C6.2 20.1 5.49999 19.6 4.89999 19C4.59999 18 4.00001 17.2 3.20001 16.6C2.80001 15.8 2.49999 15 2.29999 14.1C4.99999 14.7 7 17.1 7 20ZM10.6 9.89999C8.70001 8.09999 6.39999 6.9 3.79999 6.3C3.39999 6.9 2.99999 7.5 2.79999 8.2C5.39999 8.6 7.7 9.80001 9.5 11.6C9.8 10.9 10.2 10.4 10.6 9.89999ZM2.20001 10.1C2.10001 10.7 2 11.4 2 12C2 12 2 12 2 12.1C4.3 12.4 6.40001 13.7 7.60001 15.6C7.80001 14.8 8.09999 14.1 8.39999 13.4C6.89999 11.6 4.70001 10.4 2.20001 10.1ZM11 20C11 14 15.4 9.00001 21.2 8.10001C20.9 7.40001 20.6 6.8 20.2 6.2C13.8 7.5 9 13.1 9 19.9C9 20.4 9.00001 21 9.10001 21.5C9.80001 21.7 10.5 21.8 11.2 21.9C11.1 21.3 11 20.7 11 20ZM19.1 19C19.4 18 20 17.2 20.8 16.6C21.2 15.8 21.5 15 21.7 14.1C19 14.7 16.9 17.1 16.9 20C16.9 20.2 16.9 20.4 16.9 20.6C17.8 20.2 18.5 19.6 19.1 19ZM15 20C15 15.9 18.1 12.6 22 12.1C22 12.1 22 12.1 22 12C22 11.3 21.9 10.7 21.8 10.1C16.8 10.7 13 14.9 13 20C13 20.7 13.1 21.3 13.2 21.9C13.9 21.8 14.5 21.7 15.2 21.5C15.1 21 15 20.5 15 20Z"
        fill="mediumGray"
      ></path>
    </svg>
    <svg
        v-if="props.icon == 'euro'"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
      <mask
          id="mask0_120_4400"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
      >
        <rect width="26" height="26" />
      </mask>
      <g mask="url(#mask0_120_4400)">
        <path d="M1 11a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3zm5-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm5-5a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V2z"/>
      </g>
    </svg>
    <svg
      v-if="props.icon == 'basketball'"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        opacity="0.3"
        d="M18.4 5.59998C21.9 9.09998 21.9 14.8 18.4 18.3C14.9 21.8 9.2 21.8 5.7 18.3L18.4 5.59998Z"
        fill="rgb(156 163 175)"
      ></path>
      <path
        d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM19.9 11H13V8.8999C14.9 8.6999 16.7 8.00005 18.1 6.80005C19.1 8.00005 19.7 9.4 19.9 11ZM11 19.8999C9.7 19.6999 8.39999 19.2 7.39999 18.5C8.49999 17.7 9.7 17.2001 11 17.1001V19.8999ZM5.89999 6.90002C7.39999 8.10002 9.2 8.8 11 9V11.1001H4.10001C4.30001 9.4001 4.89999 8.00002 5.89999 6.90002ZM7.39999 5.5C8.49999 4.7 9.7 4.19998 11 4.09998V7C9.7 6.8 8.39999 6.3 7.39999 5.5ZM13 17.1001C14.3 17.3001 15.6 17.8 16.6 18.5C15.5 19.3 14.3 19.7999 13 19.8999V17.1001ZM13 4.09998C14.3 4.29998 15.6 4.8 16.6 5.5C15.5 6.3 14.3 6.80002 13 6.90002V4.09998ZM4.10001 13H11V15.1001C9.1 15.3001 7.29999 16 5.89999 17.2C4.89999 16 4.30001 14.6 4.10001 13ZM18.1 17.1001C16.6 15.9001 14.8 15.2 13 15V12.8999H19.9C19.7 14.5999 19.1 16.0001 18.1 17.1001Z"
        fill="mediumGray"
      ></path>
    </svg>
    <svg
      v-if="props.icon == 'rect-charts'"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        opacity="0.3"
        d="M14 3V21H10V3C10 2.4 10.4 2 11 2H13C13.6 2 14 2.4 14 3ZM7 14H5C4.4 14 4 14.4 4 15V21H8V15C8 14.4 7.6 14 7 14Z"
        fill="currentColor"
      ></path>
      <path
        d="M21 20H20V8C20 7.4 19.6 7 19 7H17C16.4 7 16 7.4 16 8V20H3C2.4 20 2 20.4 2 21C2 21.6 2.4 22 3 22H21C21.6 22 22 21.6 22 21C22 20.4 21.6 20 21 20Z"
        fill="mediumGray"
      ></path>
    </svg>
    <svg
      v-if="props.icon == '3d-map'"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        d="M8.7 4.19995L4 6.30005V18.8999L8.7 16.8V19L3.1 21.5C2.6 21.7 2 21.4 2 20.8V6C2 5.4 2.3 4.89995 2.9 4.69995L8.7 2.09998V4.19995Z"
        fill="mediumGray"
      ></path>
      <path
        d="M15.3 19.8L20 17.6999V5.09992L15.3 7.19989V4.99994L20.9 2.49994C21.4 2.29994 22 2.59989 22 3.19989V17.9999C22 18.5999 21.7 19.1 21.1 19.3L15.3 21.8998V19.8Z"
        fill="mediumGray"
      ></path>
      <path
        opacity="0.3"
        d="M15.3 7.19995L20 5.09998V17.7L15.3 19.8V7.19995Z"
        fill="currentColor"
      ></path>
      <path
        opacity="0.3"
        d="M8.70001 4.19995V2L15.4 5V7.19995L8.70001 4.19995ZM8.70001 16.8V19L15.4 22V19.8L8.70001 16.8Z"
        fill="currentColor"
      ></path>
      <path
        opacity="0.3"
        d="M8.7 16.8L4 18.8999V6.30005L8.7 4.19995V16.8Z"
        fill="currentColor"
      ></path>
    </svg>
    <svg
      v-if="props.icon == 'puzzle-circle'"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        opacity="0.3"
        d="M2.10001 10C3.00001 5.6 6.69998 2.3 11.2 2L8.79999 4.39999L11.1 7C9.60001 7.3 8.30001 8.19999 7.60001 9.59999L4.5 12.4L2.10001 10ZM19.3 11.5L16.4 14C15.7 15.5 14.4 16.6 12.7 16.9L15 19.5L12.6 21.9C17.1 21.6 20.8 18.2 21.7 13.9L19.3 11.5Z"
        fill="currentColor"
      ></path>
      <path
        d="M13.8 2.09998C18.2 2.99998 21.5 6.69998 21.8 11.2L19.4 8.79997L16.8 11C16.5 9.39998 15.5 8.09998 14 7.39998L11.4 4.39998L13.8 2.09998ZM12.3 19.4L9.69998 16.4C8.29998 15.7 7.3 14.4 7 12.8L4.39999 15.1L2 12.7C2.3 17.2 5.7 20.9 10 21.8L12.3 19.4Z"
        fill="mediumGray"
      ></path>
    </svg>
    <svg
      v-if="props.icon == 'layers'"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path
        opacity="0.3"
        d="M21.25 18.525L13.05 21.825C12.35 22.125 11.65 22.125 10.95 21.825L2.75 18.525C1.75 18.125 1.75 16.725 2.75 16.325L4.04999 15.825L10.25 18.325C10.85 18.525 11.45 18.625 12.05 18.625C12.65 18.625 13.25 18.525 13.85 18.325L20.05 15.825L21.35 16.325C22.35 16.725 22.35 18.125 21.25 18.525ZM13.05 16.425L21.25 13.125C22.25 12.725 22.25 11.325 21.25 10.925L13.05 7.62502C12.35 7.32502 11.65 7.32502 10.95 7.62502L2.75 10.925C1.75 11.325 1.75 12.725 2.75 13.125L10.95 16.425C11.65 16.725 12.45 16.725 13.05 16.425Z"
        fill="currentColor"
      ></path>
      <path
        d="M11.05 11.025L2.84998 7.725C1.84998 7.325 1.84998 5.925 2.84998 5.525L11.05 2.225C11.75 1.925 12.45 1.925 13.15 2.225L21.35 5.525C22.35 5.925 22.35 7.325 21.35 7.725L13.05 11.025C12.45 11.325 11.65 11.325 11.05 11.025Z"
        fill="mediumGray"
      ></path>
    </svg>
    <svg
      v-if="props.icon == 'es'"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 20 10"
    >
      <g id="surface1">
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(77.254902%, 12.54902%, 14.901961%);
            fill-opacity: 1;
          "
          d="M 1.160156 0 L 18.835938 0 C 19.4375 0 19.929688 0.355469 19.929688 0.789062 L 19.929688 9.207031 C 19.929688 9.644531 19.433594 9.996094 18.835938 9.996094 L 1.160156 9.996094 C 0.5625 10 0.0664062 9.644531 0.0664062 9.210938 L 0.0664062 0.789062 C 0.0664062 0.355469 0.5625 0 1.160156 0 Z M 1.160156 0 "
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(100%, 77.647059%, 4.313725%);
            fill-opacity: 1;
          "
          d="M 0.0664062 7.730469 L 19.933594 7.730469 L 19.933594 2.269531 L 0.0664062 2.269531 Z M 0.0664062 7.730469 "
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 9.949342 14.79 L 11.816447 14.79 L 11.816447 14.295 L 9.949342 14.295 Z M 9.949342 14.79 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: round;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 10.144737 15.12 C 10.155592 15.105 10.166447 15.105 10.177303 15.105 L 11.577632 15.105 C 11.588487 15.105 11.610197 15.105 11.621053 15.12 C 11.566776 15.105 11.545066 15.06 11.545066 15.015 C 11.545066 14.955 11.577632 14.91 11.631908 14.895 C 11.621053 14.895 11.599342 14.91 11.588487 14.91 L 10.188158 14.91 C 10.177303 14.91 10.155592 14.91 10.144737 14.895 L 10.155592 14.895 C 10.209868 14.925 10.242434 14.955 10.242434 15.015 C 10.231579 15.06 10.199013 15.105 10.144737 15.12 Z M 10.144737 15.12 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 10.177303 15.105 L 11.577632 15.105 C 11.631908 15.105 11.675329 15.135 11.675329 15.18 C 11.675329 15.225 11.631908 15.255 11.577632 15.255 L 10.177303 15.255 C 10.133882 15.255 10.090461 15.225 10.090461 15.18 C 10.101316 15.135 10.144737 15.105 10.177303 15.105 Z M 10.177303 15.105 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 10.177303 14.79 L 11.577632 14.79 C 11.631908 14.79 11.675329 14.82 11.675329 14.85 C 11.675329 14.88 11.631908 14.91 11.577632 14.91 L 10.177303 14.91 C 10.133882 14.91 10.090461 14.88 10.090461 14.85 C 10.101316 14.82 10.144737 14.79 10.177303 14.79 Z M 10.177303 14.79 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(14.901961%, 36.862745%, 67.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 12.185526 23.04 C 12.055263 23.04 11.946711 23.01 11.859868 22.965 C 11.783882 22.935 11.664474 22.905 11.545066 22.905 C 11.414803 22.905 11.295395 22.935 11.208553 22.965 C 11.132566 23.01 11.013158 23.04 10.882895 23.04 C 10.752632 23.04 10.644079 23.01 10.546382 22.965 C 10.470395 22.92 10.350987 22.89 10.231579 22.89 C 10.101316 22.89 9.992763 22.92 9.905921 22.965 C 9.819079 22.995 9.710526 23.025 9.580263 23.025 L 9.580263 23.235 C 9.710526 23.235 9.829934 23.205 9.905921 23.16 C 9.992763 23.115 10.112171 23.085 10.231579 23.085 C 10.350987 23.085 10.459539 23.115 10.546382 23.16 C 10.633224 23.205 10.752632 23.235 10.882895 23.235 C 11.013158 23.235 11.121711 23.205 11.208553 23.16 C 11.295395 23.115 11.414803 23.085 11.545066 23.085 C 11.675329 23.085 11.783882 23.115 11.859868 23.16 C 11.946711 23.205 12.055263 23.235 12.185526 23.235 Z M 12.185526 23.04 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(80.392157%, 80%, 79.607843%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 12.185526 23.235 C 12.055263 23.235 11.946711 23.205 11.859868 23.175 C 11.783882 23.13 11.664474 23.1 11.545066 23.1 C 11.414803 23.1 11.295395 23.13 11.208553 23.175 C 11.132566 23.205 11.013158 23.235 10.882895 23.235 C 10.752632 23.235 10.644079 23.205 10.546382 23.175 C 10.470395 23.13 10.350987 23.1 10.231579 23.1 C 10.101316 23.1 9.992763 23.13 9.905921 23.175 C 9.819079 23.205 9.710526 23.235 9.580263 23.235 L 9.580263 23.445 C 9.710526 23.445 9.829934 23.415 9.905921 23.37 C 9.992763 23.325 10.112171 23.295 10.231579 23.295 C 10.350987 23.295 10.459539 23.325 10.546382 23.37 C 10.633224 23.415 10.752632 23.445 10.882895 23.445 C 11.013158 23.445 11.121711 23.415 11.208553 23.385 C 11.295395 23.34 11.414803 23.31 11.545066 23.31 C 11.675329 23.31 11.783882 23.34 11.859868 23.385 C 11.946711 23.415 12.055263 23.445 12.185526 23.445 Z M 12.185526 23.235 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(14.901961%, 36.862745%, 67.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 12.185526 23.445 C 12.055263 23.445 11.946711 23.415 11.859868 23.37 C 11.783882 23.325 11.664474 23.295 11.545066 23.295 C 11.414803 23.295 11.295395 23.325 11.208553 23.37 C 11.132566 23.415 11.013158 23.445 10.882895 23.445 C 10.752632 23.445 10.644079 23.415 10.546382 23.355 C 10.470395 23.325 10.350987 23.295 10.231579 23.295 C 10.101316 23.295 9.992763 23.325 9.905921 23.355 C 9.819079 23.4 9.710526 23.43 9.580263 23.43 L 9.580263 23.625 C 9.710526 23.625 9.829934 23.595 9.905921 23.565 C 9.992763 23.52 10.112171 23.49 10.231579 23.49 C 10.350987 23.49 10.459539 23.505 10.546382 23.565 C 10.633224 23.595 10.752632 23.625 10.882895 23.625 C 11.013158 23.625 11.121711 23.595 11.208553 23.565 C 11.295395 23.52 11.414803 23.49 11.545066 23.49 C 11.675329 23.49 11.783882 23.52 11.859868 23.565 C 11.946711 23.595 12.055263 23.625 12.185526 23.625 Z M 12.185526 23.445 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(80.392157%, 80%, 79.607843%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 12.185526 23.85 C 12.055263 23.85 11.946711 23.82 11.859868 23.775 C 11.783882 23.745 11.664474 23.715 11.545066 23.715 C 11.414803 23.715 11.295395 23.745 11.208553 23.775 C 11.132566 23.82 11.013158 23.85 10.882895 23.85 C 10.752632 23.85 10.644079 23.82 10.546382 23.775 C 10.470395 23.73 10.350987 23.7 10.231579 23.7 C 10.101316 23.7 9.992763 23.715 9.905921 23.775 C 9.819079 23.805 9.710526 23.835 9.580263 23.835 L 9.580263 23.64 C 9.710526 23.64 9.829934 23.61 9.905921 23.565 C 9.992763 23.52 10.112171 23.49 10.231579 23.49 C 10.350987 23.49 10.459539 23.505 10.546382 23.565 C 10.633224 23.595 10.752632 23.625 10.882895 23.625 C 11.013158 23.625 11.121711 23.595 11.208553 23.565 C 11.295395 23.52 11.414803 23.49 11.545066 23.49 C 11.675329 23.49 11.783882 23.52 11.859868 23.565 C 11.946711 23.595 12.055263 23.625 12.185526 23.625 Z M 12.185526 23.85 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(14.901961%, 36.862745%, 67.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 12.185526 24.045 C 12.055263 24.045 11.946711 24.015 11.859868 23.985 C 11.783882 23.94 11.664474 23.91 11.545066 23.91 C 11.414803 23.91 11.295395 23.94 11.208553 23.985 C 11.132566 24.015 11.013158 24.045 10.882895 24.045 C 10.752632 24.045 10.644079 24.015 10.546382 23.985 C 10.470395 23.94 10.350987 23.91 10.231579 23.91 C 10.101316 23.91 9.992763 23.94 9.905921 23.985 C 9.819079 24.015 9.710526 24.045 9.580263 24.045 L 9.580263 23.85 C 9.710526 23.85 9.829934 23.82 9.905921 23.775 C 9.992763 23.73 10.112171 23.7 10.231579 23.7 C 10.350987 23.7 10.459539 23.73 10.546382 23.775 C 10.633224 23.805 10.752632 23.85 10.882895 23.85 C 11.013158 23.85 11.121711 23.82 11.208553 23.775 C 11.295395 23.745 11.414803 23.715 11.545066 23.715 C 11.675329 23.715 11.783882 23.745 11.859868 23.775 C 11.946711 23.835 12.055263 23.85 12.185526 23.85 Z M 12.185526 24.045 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: round;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 10.144737 22.215 C 10.144737 22.23 10.155592 22.245 10.155592 22.26 C 10.155592 22.38 10.047039 22.485 9.916776 22.485 L 11.838158 22.485 C 11.707895 22.485 11.599342 22.38 11.599342 22.26 C 11.599342 22.245 11.599342 22.23 11.610197 22.215 C 11.599342 22.215 11.588487 22.215 11.566776 22.215 L 10.166447 22.215 C 10.166447 22.215 10.155592 22.215 10.144737 22.215 Z M 10.144737 22.215 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 10.177303 22.08 L 11.577632 22.08 C 11.631908 22.08 11.675329 22.11 11.675329 22.14 C 11.675329 22.185 11.631908 22.215 11.577632 22.215 L 10.177303 22.215 C 10.133882 22.215 10.090461 22.185 10.090461 22.14 C 10.101316 22.11 10.144737 22.08 10.177303 22.08 Z M 10.177303 22.08 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 9.927632 22.965 L 11.838158 22.965 L 11.838158 22.485 L 9.927632 22.485 Z M 9.927632 22.965 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 9.775658 20.355 C 9.591118 20.46 9.460855 20.565 9.482566 20.625 C 9.493421 20.685 9.547697 20.715 9.645395 20.775 C 9.775658 20.88 9.8625 21.045 9.786513 21.12 C 9.895066 21.03 9.971053 20.895 9.971053 20.745 C 9.971053 20.58 9.895066 20.445 9.775658 20.355 Z M 9.775658 20.355 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(80.392157%, 80%, 79.607843%);
            fill-opacity: 1;
          "
          d="M 3.738281 5.730469 L 4.226562 5.730469 L 4.226562 3.988281 L 3.738281 3.988281 Z M 3.738281 5.730469 "
        ></path>
        <path
          style="
            fill: none;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 11.327961 15.33 L 11.327961 21.99 M 11.165132 15.33 L 11.165132 21.99 M 10.199013 22.005 L 11.555921 22.005 L 11.555921 15.315 L 10.199013 15.315 Z M 10.199013 22.005 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: round;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 12.95625 17.82 C 12.663158 17.7 12.163816 17.61 11.577632 17.595 C 11.382237 17.595 11.165132 17.61 10.926316 17.655 C 10.123026 17.79 9.493421 18.105 9.536842 18.375 C 9.536842 18.375 9.536842 18.405 9.536842 18.405 C 9.536842 18.405 9.232895 17.715 9.232895 17.685 C 9.178618 17.4 9.8625 17.025 10.774342 16.875 C 11.045724 16.83 11.327961 16.815 11.566776 16.815 C 12.152961 16.815 12.652303 16.89 12.95625 17.01 Z M 12.95625 17.82 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 10.199013 18.66 C 9.819079 18.63 9.558553 18.525 9.525987 18.375 C 9.515132 18.24 9.634539 18.105 9.8625 17.985 C 9.971053 17.985 10.079605 18 10.199013 18 Z M 10.199013 18.66 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 11.566776 18.15 C 11.805592 18.195 11.979276 18.24 12.066118 18.315 L 12.076974 18.33 C 12.120395 18.42 11.914145 18.6 11.566776 18.81 Z M 11.566776 18.15 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: round;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 9.352303 19.95 C 9.308882 19.845 9.677961 19.635 10.199013 19.44 C 10.437829 19.35 10.633224 19.275 10.882895 19.155 C 11.599342 18.84 12.142105 18.465 12.066118 18.345 L 12.055263 18.33 C 12.098684 18.36 12.163816 19.02 12.163816 19.02 C 12.218092 19.14 11.740461 19.5 11.067434 19.815 C 10.861184 19.92 10.405263 20.085 10.188158 20.16 C 9.808224 20.295 9.428289 20.535 9.471711 20.625 Z M 9.352303 19.95 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 3.671875 4.492188 L 3.691406 4.488281 C 3.710938 4.480469 3.726562 4.488281 3.738281 4.503906 C 3.746094 4.515625 3.742188 4.527344 3.722656 4.539062 C 3.71875 4.542969 3.710938 4.542969 3.703125 4.546875 Z M 3.707031 4.558594 C 3.765625 4.542969 3.808594 4.523438 3.785156 4.488281 C 3.773438 4.46875 3.742188 4.464844 3.695312 4.476562 L 3.613281 4.496094 L 3.683594 4.628906 C 3.691406 4.628906 3.699219 4.625 3.710938 4.621094 C 3.71875 4.621094 3.726562 4.617188 3.734375 4.617188 Z M 3.707031 4.558594 "
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 3.898438 4.4375 C 3.890625 4.441406 3.878906 4.441406 3.871094 4.441406 C 3.863281 4.441406 3.855469 4.445312 3.847656 4.445312 L 3.890625 4.582031 L 4.023438 4.566406 C 4.023438 4.5625 4.019531 4.558594 4.019531 4.558594 C 4.019531 4.554688 4.019531 4.550781 4.019531 4.550781 C 3.996094 4.554688 3.972656 4.558594 3.941406 4.566406 Z M 3.898438 4.4375 "
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 4.164062 4.558594 C 4.1875 4.507812 4.21875 4.460938 4.25 4.410156 C 4.242188 4.410156 4.238281 4.414062 4.234375 4.414062 C 4.226562 4.414062 4.222656 4.414062 4.21875 4.414062 C 4.203125 4.449219 4.179688 4.484375 4.160156 4.519531 C 4.132812 4.484375 4.105469 4.453125 4.085938 4.417969 C 4.078125 4.417969 4.066406 4.421875 4.054688 4.421875 C 4.042969 4.421875 4.035156 4.421875 4.023438 4.421875 C 4.0625 4.464844 4.097656 4.511719 4.132812 4.558594 C 4.136719 4.558594 4.144531 4.554688 4.148438 4.554688 C 4.152344 4.554688 4.15625 4.558594 4.164062 4.558594 Z M 4.164062 4.558594 "
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 4.441406 4.449219 C 4.445312 4.441406 4.449219 4.4375 4.453125 4.433594 C 4.449219 4.425781 4.425781 4.417969 4.402344 4.417969 C 4.347656 4.414062 4.3125 4.433594 4.3125 4.457031 C 4.304688 4.503906 4.410156 4.5 4.40625 4.535156 C 4.402344 4.546875 4.382812 4.554688 4.359375 4.550781 C 4.335938 4.550781 4.316406 4.542969 4.3125 4.527344 L 4.308594 4.527344 C 4.304688 4.535156 4.300781 4.542969 4.292969 4.550781 C 4.308594 4.558594 4.328125 4.5625 4.351562 4.566406 C 4.40625 4.570312 4.449219 4.554688 4.449219 4.527344 C 4.457031 4.480469 4.351562 4.476562 4.355469 4.449219 C 4.355469 4.4375 4.367188 4.429688 4.398438 4.429688 C 4.417969 4.433594 4.429688 4.441406 4.4375 4.449219 Z M 4.441406 4.449219 "
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 22.454605 14.79 L 24.332566 14.79 L 24.332566 14.295 L 22.454605 14.295 Z M 22.454605 14.79 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: round;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 24.126316 15.12 C 24.115461 15.105 24.104605 15.105 24.104605 15.105 L 22.704276 15.105 C 22.693421 15.105 22.671711 15.105 22.660855 15.12 C 22.715132 15.105 22.736842 15.06 22.736842 15.015 C 22.736842 14.955 22.704276 14.91 22.65 14.895 C 22.660855 14.895 22.682566 14.91 22.693421 14.91 L 24.09375 14.91 C 24.104605 14.91 24.115461 14.91 24.126316 14.895 L 24.115461 14.895 C 24.072039 14.925 24.039474 14.955 24.039474 15.015 C 24.050329 15.06 24.082895 15.105 24.126316 15.12 Z M 24.126316 15.12 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 22.704276 15.105 L 24.104605 15.105 C 24.148026 15.105 24.191447 15.135 24.191447 15.18 C 24.191447 15.225 24.148026 15.255 24.104605 15.255 L 22.704276 15.255 C 22.65 15.255 22.606579 15.225 22.606579 15.18 C 22.606579 15.135 22.65 15.105 22.704276 15.105 Z M 22.704276 15.105 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 22.704276 14.79 L 24.104605 14.79 C 24.148026 14.79 24.191447 14.82 24.191447 14.85 C 24.191447 14.88 24.148026 14.91 24.104605 14.91 L 22.704276 14.91 C 22.65 14.91 22.606579 14.88 22.606579 14.85 C 22.606579 14.82 22.65 14.79 22.704276 14.79 Z M 22.704276 14.79 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(14.901961%, 36.862745%, 67.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 22.085526 23.04 C 22.215789 23.04 22.335197 23.01 22.422039 22.965 C 22.498026 22.935 22.617434 22.905 22.736842 22.905 C 22.867105 22.905 22.975658 22.935 23.073355 22.965 C 23.149342 23.01 23.26875 23.04 23.399013 23.04 C 23.529276 23.04 23.637829 23.01 23.724671 22.965 C 23.811513 22.92 23.930921 22.89 24.050329 22.89 C 24.180592 22.89 24.289145 22.92 24.365132 22.965 C 24.451974 22.995 24.571382 23.025 24.701645 23.025 L 24.701645 23.235 C 24.571382 23.235 24.451974 23.205 24.365132 23.16 C 24.289145 23.115 24.169737 23.085 24.050329 23.085 C 23.930921 23.085 23.822368 23.115 23.724671 23.16 C 23.648684 23.205 23.529276 23.235 23.399013 23.235 C 23.26875 23.235 23.160197 23.205 23.073355 23.16 C 22.986513 23.115 22.867105 23.085 22.736842 23.085 C 22.606579 23.085 22.498026 23.115 22.422039 23.16 C 22.335197 23.205 22.215789 23.235 22.085526 23.235 Z M 22.085526 23.04 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(80.392157%, 80%, 79.607843%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 22.085526 23.235 C 22.215789 23.235 22.335197 23.205 22.422039 23.175 C 22.498026 23.13 22.617434 23.1 22.736842 23.1 C 22.867105 23.1 22.975658 23.13 23.073355 23.175 C 23.149342 23.205 23.26875 23.235 23.399013 23.235 C 23.529276 23.235 23.637829 23.205 23.724671 23.175 C 23.811513 23.13 23.930921 23.1 24.050329 23.1 C 24.180592 23.1 24.289145 23.13 24.365132 23.175 C 24.451974 23.205 24.571382 23.235 24.701645 23.235 L 24.701645 23.445 C 24.571382 23.445 24.451974 23.415 24.365132 23.37 C 24.289145 23.325 24.169737 23.295 24.050329 23.295 C 23.930921 23.295 23.822368 23.325 23.724671 23.37 C 23.648684 23.415 23.529276 23.445 23.399013 23.445 C 23.26875 23.445 23.160197 23.415 23.073355 23.385 C 22.975658 23.34 22.867105 23.31 22.736842 23.31 C 22.606579 23.31 22.498026 23.34 22.422039 23.385 C 22.335197 23.415 22.215789 23.445 22.085526 23.445 Z M 22.085526 23.235 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(14.901961%, 36.862745%, 67.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 22.085526 23.445 C 22.215789 23.445 22.335197 23.415 22.422039 23.37 C 22.498026 23.325 22.617434 23.295 22.736842 23.295 C 22.867105 23.295 22.975658 23.325 23.073355 23.37 C 23.149342 23.415 23.26875 23.445 23.399013 23.445 C 23.529276 23.445 23.637829 23.415 23.724671 23.355 C 23.811513 23.325 23.930921 23.295 24.050329 23.295 C 24.180592 23.295 24.289145 23.325 24.365132 23.355 C 24.451974 23.4 24.571382 23.43 24.701645 23.43 L 24.701645 23.625 C 24.571382 23.625 24.451974 23.595 24.365132 23.565 C 24.289145 23.52 24.169737 23.49 24.050329 23.49 C 23.930921 23.49 23.822368 23.505 23.724671 23.565 C 23.648684 23.595 23.529276 23.625 23.399013 23.625 C 23.26875 23.625 23.160197 23.595 23.073355 23.565 C 22.986513 23.52 22.867105 23.49 22.736842 23.49 C 22.606579 23.49 22.498026 23.52 22.422039 23.565 C 22.335197 23.595 22.215789 23.625 22.085526 23.625 Z M 22.085526 23.445 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(80.392157%, 80%, 79.607843%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 22.085526 23.85 C 22.215789 23.85 22.335197 23.82 22.422039 23.775 C 22.498026 23.745 22.617434 23.715 22.736842 23.715 C 22.867105 23.715 22.975658 23.745 23.073355 23.775 C 23.149342 23.82 23.26875 23.85 23.399013 23.85 C 23.529276 23.85 23.637829 23.82 23.724671 23.775 C 23.811513 23.73 23.930921 23.7 24.050329 23.7 C 24.180592 23.7 24.289145 23.715 24.365132 23.775 C 24.451974 23.82 24.571382 23.835 24.701645 23.835 L 24.701645 23.64 C 24.571382 23.64 24.451974 23.61 24.365132 23.565 C 24.289145 23.52 24.169737 23.49 24.050329 23.49 C 23.930921 23.49 23.822368 23.505 23.724671 23.565 C 23.648684 23.595 23.529276 23.625 23.399013 23.625 C 23.26875 23.625 23.160197 23.595 23.073355 23.565 C 22.986513 23.52 22.867105 23.49 22.736842 23.49 C 22.606579 23.49 22.498026 23.52 22.422039 23.565 C 22.335197 23.595 22.215789 23.625 22.085526 23.625 Z M 22.085526 23.85 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(14.901961%, 36.862745%, 67.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 22.085526 24.045 C 22.215789 24.045 22.335197 24.015 22.422039 23.985 C 22.498026 23.94 22.617434 23.91 22.736842 23.91 C 22.867105 23.91 22.975658 23.94 23.073355 23.985 C 23.149342 24.015 23.26875 24.045 23.399013 24.045 C 23.529276 24.045 23.637829 24.015 23.724671 23.985 C 23.811513 23.94 23.930921 23.91 24.050329 23.91 C 24.180592 23.91 24.289145 23.94 24.365132 23.985 C 24.451974 24.015 24.571382 24.045 24.701645 24.045 L 24.701645 23.85 C 24.571382 23.85 24.451974 23.82 24.365132 23.775 C 24.289145 23.715 24.169737 23.7 24.050329 23.7 C 23.930921 23.7 23.822368 23.73 23.724671 23.775 C 23.648684 23.805 23.529276 23.85 23.399013 23.85 C 23.26875 23.85 23.160197 23.82 23.073355 23.775 C 22.986513 23.745 22.867105 23.715 22.736842 23.715 C 22.606579 23.715 22.498026 23.745 22.422039 23.775 C 22.335197 23.835 22.215789 23.85 22.085526 23.85 Z M 22.085526 24.045 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: round;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 24.126316 22.215 C 24.126316 22.23 24.115461 22.245 24.115461 22.26 C 24.115461 22.38 24.234868 22.485 24.365132 22.485 L 22.44375 22.485 C 22.574013 22.485 22.682566 22.38 22.682566 22.26 C 22.682566 22.245 22.682566 22.23 22.671711 22.215 C 22.682566 22.215 22.693421 22.215 22.715132 22.215 L 24.104605 22.215 C 24.104605 22.215 24.115461 22.215 24.126316 22.215 Z M 24.126316 22.215 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 22.704276 22.08 L 24.104605 22.08 C 24.148026 22.08 24.191447 22.11 24.191447 22.14 C 24.191447 22.185 24.148026 22.215 24.104605 22.215 L 22.704276 22.215 C 22.65 22.215 22.606579 22.185 22.606579 22.14 C 22.606579 22.11 22.65 22.08 22.704276 22.08 Z M 22.704276 22.08 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 22.44375 22.965 L 24.354276 22.965 L 24.354276 22.485 L 22.44375 22.485 Z M 22.44375 22.965 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 24.50625 20.355 C 24.701645 20.46 24.831908 20.565 24.810197 20.625 C 24.799342 20.685 24.745066 20.715 24.647368 20.775 C 24.50625 20.88 24.430263 21.045 24.495395 21.12 C 24.386842 21.03 24.321711 20.895 24.321711 20.745 C 24.310855 20.58 24.375987 20.445 24.50625 20.355 Z M 24.50625 20.355 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(80.392157%, 80%, 79.607843%);
            fill-opacity: 1;
          "
          d="M 8.242188 5.730469 L 8.734375 5.730469 L 8.734375 3.988281 L 8.242188 3.988281 Z M 8.242188 5.730469 "
        ></path>
        <path
          style="
            fill: none;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 23.854934 15.315 L 23.854934 21.975 M 23.713816 15.315 L 23.713816 21.975 M 22.715132 22.005 L 24.082895 22.005 L 24.082895 15.315 L 22.715132 15.315 Z M 22.715132 22.005 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: round;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 21.314803 17.82 C 21.61875 17.7 22.118092 17.61 22.704276 17.595 C 22.899671 17.595 23.116776 17.61 23.344737 17.655 C 24.169737 17.79 24.788487 18.105 24.745066 18.375 C 24.745066 18.375 24.745066 18.405 24.745066 18.405 C 24.745066 18.405 25.049013 17.715 25.049013 17.685 C 25.103289 17.4 24.419408 17.025 23.507566 16.875 C 23.225329 16.83 22.953947 16.815 22.715132 16.815 C 22.128947 16.815 21.629605 16.89 21.314803 17.01 Z M 21.314803 17.82 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 24.082895 18.66 C 24.462829 18.63 24.723355 18.525 24.745066 18.375 C 24.766776 18.24 24.647368 18.105 24.419408 17.985 C 24.310855 17.985 24.202303 18 24.082895 18 Z M 24.082895 18.66 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 22.715132 18.15 C 22.465461 18.195 22.302632 18.24 22.204934 18.315 L 22.204934 18.33 C 22.161513 18.42 22.367763 18.6 22.715132 18.81 Z M 22.715132 18.15 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: round;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 24.929605 19.95 C 24.973026 19.845 24.603947 19.635 24.082895 19.44 C 23.844079 19.35 23.637829 19.275 23.399013 19.155 C 22.682566 18.84 22.139803 18.465 22.204934 18.345 L 22.215789 18.33 C 22.183224 18.36 22.118092 19.02 22.118092 19.02 C 22.052961 19.14 22.541447 19.5 23.214474 19.815 C 23.420724 19.92 23.865789 20.085 24.09375 20.16 C 24.473684 20.295 24.853618 20.535 24.810197 20.625 Z M 24.929605 19.95 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 8.046875 4.566406 C 8.0625 4.511719 8.089844 4.464844 8.109375 4.414062 C 8.105469 4.414062 8.101562 4.417969 8.097656 4.417969 C 8.09375 4.417969 8.085938 4.417969 8.082031 4.417969 C 8.070312 4.453125 8.058594 4.488281 8.039062 4.523438 C 8.011719 4.492188 7.976562 4.460938 7.953125 4.429688 C 7.941406 4.433594 7.929688 4.433594 7.921875 4.433594 C 7.910156 4.433594 7.898438 4.4375 7.886719 4.4375 C 7.929688 4.480469 7.972656 4.523438 8.011719 4.566406 C 8.015625 4.566406 8.023438 4.566406 8.027344 4.566406 C 8.039062 4.566406 8.042969 4.566406 8.046875 4.566406 Z M 8.046875 4.566406 "
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 8.234375 4.414062 C 8.226562 4.414062 8.214844 4.414062 8.207031 4.414062 C 8.199219 4.414062 8.191406 4.414062 8.183594 4.410156 L 8.179688 4.550781 L 8.316406 4.554688 C 8.316406 4.550781 8.3125 4.550781 8.3125 4.546875 C 8.3125 4.542969 8.3125 4.542969 8.316406 4.539062 C 8.289062 4.539062 8.265625 4.542969 8.234375 4.542969 Z M 8.234375 4.414062 "
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 8.445312 4.4375 C 8.46875 4.441406 8.488281 4.441406 8.511719 4.445312 C 8.511719 4.441406 8.511719 4.441406 8.511719 4.4375 C 8.511719 4.433594 8.511719 4.433594 8.515625 4.429688 L 8.332031 4.417969 C 8.332031 4.421875 8.332031 4.425781 8.332031 4.425781 C 8.332031 4.429688 8.332031 4.433594 8.328125 4.433594 C 8.34375 4.433594 8.371094 4.433594 8.394531 4.433594 L 8.378906 4.558594 C 8.386719 4.558594 8.398438 4.558594 8.40625 4.558594 C 8.417969 4.558594 8.425781 4.5625 8.429688 4.5625 Z M 8.445312 4.4375 "
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 8.613281 4.457031 C 8.636719 4.460938 8.660156 4.464844 8.660156 4.480469 C 8.660156 4.488281 8.660156 4.488281 8.65625 4.492188 C 8.652344 4.511719 8.628906 4.519531 8.59375 4.511719 Z M 8.519531 4.574219 C 8.527344 4.574219 8.539062 4.578125 8.546875 4.578125 C 8.554688 4.578125 8.5625 4.582031 8.570312 4.582031 L 8.59375 4.519531 L 8.597656 4.519531 C 8.601562 4.527344 8.605469 4.539062 8.609375 4.542969 L 8.640625 4.59375 C 8.652344 4.597656 8.660156 4.597656 8.671875 4.597656 C 8.683594 4.601562 8.695312 4.605469 8.703125 4.605469 L 8.695312 4.589844 C 8.679688 4.566406 8.664062 4.542969 8.652344 4.523438 C 8.683594 4.523438 8.710938 4.515625 8.714844 4.496094 C 8.71875 4.480469 8.710938 4.472656 8.695312 4.460938 C 8.679688 4.453125 8.652344 4.449219 8.640625 4.449219 L 8.566406 4.4375 Z M 8.519531 4.574219 "
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 8.816406 4.582031 L 8.882812 4.554688 L 8.875 4.605469 Z M 8.871094 4.617188 C 8.871094 4.632812 8.867188 4.644531 8.859375 4.664062 C 8.871094 4.667969 8.878906 4.667969 8.886719 4.675781 C 8.894531 4.675781 8.90625 4.683594 8.914062 4.683594 L 8.929688 4.527344 C 8.925781 4.527344 8.925781 4.523438 8.921875 4.519531 C 8.917969 4.519531 8.914062 4.519531 8.910156 4.515625 L 8.714844 4.605469 C 8.71875 4.605469 8.726562 4.605469 8.730469 4.609375 C 8.734375 4.613281 8.742188 4.613281 8.742188 4.613281 C 8.761719 4.605469 8.777344 4.597656 8.796875 4.585938 Z M 8.871094 4.617188 "
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(80.392157%, 80%, 79.607843%);
            fill-opacity: 1;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 17.157237 24.18 C 16.060855 24.18 14.975329 23.91 14.063487 23.46 C 13.390461 23.13 12.945395 22.455 12.945395 21.675 L 12.945395 18.9 L 21.358224 18.9 L 21.358224 21.69 C 21.358224 22.455 20.913158 23.13 20.240132 23.475 C 19.328289 23.91 18.264474 24.18 17.157237 24.18 Z M 17.157237 24.18 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
          "
          d="M 6.234375 5.648438 C 6.234375 5.933594 5.898438 6.167969 5.480469 6.167969 C 5.0625 6.167969 4.722656 5.9375 4.722656 5.648438 L 4.722656 4.917969 L 6.234375 4.917969 Z M 6.234375 5.648438 "
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 16.679605 22.92 C 16.885855 22.74 17.08125 22.32 17.146382 21.855 L 17.157237 18.795 L 16.66875 18.795 Z M 16.679605 22.92 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(80.392157%, 80%, 79.607843%);
            fill-opacity: 1;
          "
          d="M 6.234375 4.917969 L 7.753906 4.917969 L 7.753906 3.703125 L 6.234375 3.703125 Z M 6.234375 4.917969 "
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 13.846382 23.325 C 13.976645 23.4 14.161184 23.52 14.356579 23.565 L 14.345724 18.78 L 13.857237 18.78 L 13.857237 23.325 Z M 13.846382 23.325 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0419;
            stroke-linecap: butt;
            stroke-linejoin: round;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 12.934539 21.645 C 12.945395 22.245 13.184211 22.68 13.412171 22.965 L 13.412171 18.81 L 12.945395 18.81 Z M 12.934539 21.645 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(77.647059%, 70.980392%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 14.790789 23.67 C 14.975329 23.685 15.127303 23.685 15.279276 23.67 L 15.279276 18.795 L 14.790789 18.795 Z M 14.790789 23.67 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 15.724342 23.565 C 15.908882 23.535 16.125987 23.415 16.234539 23.355 L 16.234539 18.795 L 15.735197 18.795 Z M 15.724342 23.565 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
          "
          d="M 4.722656 4.917969 L 6.234375 4.917969 L 6.234375 3.703125 L 4.722656 3.703125 Z M 4.722656 4.917969 "
        ></path>
        <path
          style="
            fill: none;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 12.934539 18.885 L 17.135526 18.885 L 17.135526 14.22 L 12.934539 14.22 Z M 17.135526 21.69 C 17.135526 22.785 16.201974 23.685 15.040461 23.685 C 13.878947 23.685 12.934539 22.8 12.934539 21.69 L 12.934539 18.885 L 17.135526 18.885 Z M 17.135526 21.69 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 21.358224 18.885 L 21.358224 21.69 C 21.358224 22.785 20.413816 23.685 19.252303 23.685 C 18.079934 23.685 17.135526 22.8 17.135526 21.69 L 17.135526 18.885 Z M 21.358224 18.885 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 6.964844 5.816406 L 6.914062 5.808594 L 6.914062 5.707031 L 6.964844 5.699219 Z M 7.015625 5.816406 L 7.070312 5.808594 L 7.070312 5.707031 L 7.015625 5.699219 Z M 6.957031 5.996094 C 6.957031 5.980469 6.96875 5.972656 6.992188 5.972656 C 7.007812 5.972656 7.027344 5.980469 7.027344 5.996094 C 7.027344 6.007812 7.011719 6.019531 6.992188 6.019531 C 6.972656 6.019531 6.957031 6.007812 6.957031 5.996094 Z M 7.324219 5.496094 L 7.308594 5.535156 L 7.164062 5.535156 L 7.148438 5.496094 Z M 6.65625 5.496094 L 6.671875 5.535156 L 6.816406 5.535156 L 6.828125 5.496094 Z M 7.289062 5.695312 L 7.320312 5.664062 L 7.226562 5.589844 L 7.175781 5.605469 Z M 7.25 5.71875 L 7.199219 5.734375 L 7.105469 5.660156 L 7.136719 5.628906 Z M 7.320312 5.933594 C 7.273438 5.957031 7.222656 5.976562 7.167969 5.988281 L 7.207031 6.015625 C 7.25 6.003906 7.292969 5.988281 7.332031 5.96875 Z M 7.292969 5.902344 C 7.25 5.925781 7.195312 5.945312 7.144531 5.957031 L 7.132812 5.921875 C 7.179688 5.910156 7.222656 5.894531 7.257812 5.875 Z M 7.464844 5.589844 L 7.414062 5.597656 C 7.414062 5.597656 7.410156 5.660156 7.410156 5.644531 C 7.410156 5.628906 7.402344 5.695312 7.402344 5.695312 L 7.457031 5.707031 C 7.460938 5.6875 7.464844 5.667969 7.464844 5.648438 Z M 7.511719 5.710938 L 7.566406 5.703125 L 7.574219 5.605469 L 7.519531 5.59375 L 7.519531 5.648438 C 7.519531 5.667969 7.515625 5.691406 7.511719 5.710938 Z M 7.449219 5.8125 C 7.4375 5.800781 7.414062 5.800781 7.398438 5.808594 C 7.382812 5.816406 7.378906 5.832031 7.394531 5.84375 C 7.410156 5.855469 7.429688 5.855469 7.445312 5.847656 C 7.460938 5.839844 7.460938 5.824219 7.449219 5.8125 Z M 7.253906 5.917969 L 7.28125 5.949219 C 7.324219 5.933594 7.363281 5.90625 7.394531 5.878906 C 7.417969 5.886719 7.449219 5.882812 7.472656 5.871094 C 7.511719 5.847656 7.511719 5.816406 7.484375 5.792969 L 7.480469 5.789062 C 7.503906 5.753906 7.515625 5.71875 7.519531 5.679688 L 7.46875 5.679688 C 7.464844 5.714844 7.457031 5.746094 7.4375 5.773438 C 7.421875 5.773438 7.410156 5.773438 7.394531 5.777344 L 7.265625 5.671875 L 7.226562 5.695312 L 7.355469 5.800781 C 7.335938 5.816406 7.335938 5.84375 7.359375 5.863281 C 7.328125 5.882812 7.292969 5.902344 7.253906 5.917969 Z M 6.6875 5.695312 L 6.65625 5.664062 L 6.75 5.589844 L 6.800781 5.605469 Z M 6.726562 5.71875 L 6.777344 5.734375 L 6.871094 5.660156 L 6.839844 5.628906 Z M 6.65625 5.933594 C 6.703125 5.957031 6.753906 5.976562 6.808594 5.988281 L 6.769531 6.015625 C 6.726562 6.003906 6.683594 5.988281 6.644531 5.96875 Z M 6.683594 5.902344 C 6.726562 5.925781 6.78125 5.945312 6.832031 5.957031 L 6.84375 5.921875 C 6.796875 5.910156 6.753906 5.894531 6.71875 5.875 Z M 6.507812 5.589844 L 6.5625 5.597656 C 6.5625 5.597656 6.566406 5.660156 6.5625 5.644531 C 6.5625 5.628906 6.570312 5.695312 6.570312 5.695312 L 6.515625 5.707031 C 6.507812 5.6875 6.507812 5.667969 6.507812 5.648438 Z M 6.464844 5.710938 L 6.414062 5.703125 L 6.40625 5.605469 L 6.460938 5.59375 L 6.460938 5.648438 C 6.457031 5.667969 6.460938 5.691406 6.464844 5.710938 Z M 6.53125 5.8125 C 6.546875 5.800781 6.566406 5.800781 6.582031 5.808594 C 6.597656 5.816406 6.597656 5.832031 6.585938 5.84375 C 6.570312 5.855469 6.550781 5.855469 6.535156 5.847656 C 6.519531 5.839844 6.515625 5.824219 6.53125 5.8125 Z M 6.722656 5.917969 L 6.695312 5.949219 C 6.652344 5.933594 6.613281 5.90625 6.582031 5.878906 C 6.554688 5.886719 6.523438 5.882812 6.503906 5.871094 C 6.464844 5.847656 6.460938 5.816406 6.496094 5.792969 L 6.5 5.789062 C 6.476562 5.753906 6.460938 5.71875 6.460938 5.679688 L 6.507812 5.679688 C 6.511719 5.714844 6.523438 5.746094 6.542969 5.773438 C 6.554688 5.769531 6.570312 5.773438 6.585938 5.777344 L 6.714844 5.671875 L 6.753906 5.695312 L 6.625 5.800781 C 6.644531 5.816406 6.644531 5.84375 6.621094 5.863281 C 6.652344 5.882812 6.6875 5.902344 6.722656 5.917969 Z M 7.066406 5.972656 C 7.105469 5.964844 7.144531 5.957031 7.183594 5.949219 L 7.207031 5.980469 C 7.164062 5.992188 7.117188 6.003906 7.070312 6.007812 C 7.0625 6.035156 7.03125 6.050781 6.992188 6.050781 C 6.953125 6.050781 6.917969 6.035156 6.914062 6.007812 C 6.863281 6.003906 6.816406 5.996094 6.769531 5.980469 L 6.792969 5.949219 C 6.832031 5.957031 6.871094 5.96875 6.917969 5.972656 C 6.925781 5.957031 6.941406 5.945312 6.960938 5.941406 L 6.960938 5.785156 L 7.011719 5.785156 L 7.011719 5.941406 C 7.039062 5.945312 7.058594 5.957031 7.066406 5.972656 Z M 7.28125 5.46875 L 7.28125 5.496094 L 7.417969 5.496094 C 7.425781 5.511719 7.445312 5.527344 7.46875 5.53125 L 7.46875 5.621094 L 7.519531 5.621094 L 7.519531 5.53125 C 7.554688 5.523438 7.578125 5.503906 7.578125 5.476562 C 7.578125 5.472656 7.578125 5.46875 7.578125 5.464844 L 7.527344 5.464844 C 7.53125 5.46875 7.53125 5.472656 7.53125 5.476562 C 7.53125 5.488281 7.515625 5.5 7.496094 5.5 C 7.476562 5.5 7.460938 5.488281 7.460938 5.476562 C 7.460938 5.472656 7.460938 5.46875 7.464844 5.464844 Z M 7.191406 5.46875 L 7.191406 5.496094 L 7.066406 5.496094 C 7.0625 5.5 7.0625 5.503906 7.058594 5.507812 L 7.203125 5.628906 L 7.164062 5.652344 L 7.019531 5.53125 C 7.015625 5.53125 7.015625 5.53125 7.011719 5.535156 L 7.011719 5.730469 L 6.960938 5.730469 L 6.960938 5.535156 C 6.960938 5.535156 6.960938 5.535156 6.957031 5.53125 L 6.804688 5.652344 L 6.765625 5.628906 L 6.917969 5.507812 C 6.914062 5.503906 6.914062 5.5 6.910156 5.496094 L 6.78125 5.496094 L 6.78125 5.46875 Z M 6.511719 5.46875 C 6.515625 5.472656 6.515625 5.476562 6.515625 5.480469 C 6.515625 5.492188 6.503906 5.503906 6.480469 5.503906 C 6.460938 5.503906 6.445312 5.492188 6.445312 5.480469 C 6.445312 5.472656 6.445312 5.472656 6.449219 5.46875 L 6.398438 5.46875 C 6.398438 5.472656 6.398438 5.476562 6.398438 5.480469 C 6.398438 5.503906 6.421875 5.527344 6.457031 5.535156 L 6.457031 5.621094 L 6.507812 5.621094 L 6.507812 5.535156 C 6.53125 5.527344 6.550781 5.515625 6.554688 5.5 L 6.695312 5.5 L 6.695312 5.46875 Z M 6.511719 5.46875 "
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 7.015625 5.175781 L 7.070312 5.183594 L 7.070312 5.285156 L 7.015625 5.292969 Z M 6.960938 5.175781 L 6.910156 5.183594 L 6.910156 5.285156 L 6.960938 5.292969 Z M 7.148438 5.058594 L 7.164062 5.023438 L 7.308594 5.023438 L 7.324219 5.058594 Z M 7.148438 5.09375 L 7.164062 5.128906 L 7.308594 5.128906 L 7.324219 5.09375 Z M 6.953125 5.074219 C 6.953125 5.0625 6.964844 5.050781 6.988281 5.050781 C 7.007812 5.050781 7.023438 5.0625 7.023438 5.074219 C 7.023438 5.089844 7.007812 5.097656 6.988281 5.097656 C 6.96875 5.101562 6.953125 5.089844 6.953125 5.074219 Z M 7.460938 5.074219 C 7.460938 5.0625 7.472656 5.050781 7.496094 5.050781 C 7.511719 5.050781 7.53125 5.0625 7.53125 5.074219 C 7.53125 5.089844 7.515625 5.097656 7.496094 5.097656 C 7.476562 5.101562 7.460938 5.089844 7.460938 5.074219 Z M 7.324219 5.464844 L 7.308594 5.425781 L 7.164062 5.425781 L 7.148438 5.464844 Z M 6.828125 5.058594 L 6.816406 5.023438 L 6.671875 5.023438 L 6.65625 5.058594 Z M 6.828125 5.09375 L 6.816406 5.128906 L 6.671875 5.128906 L 6.65625 5.09375 Z M 6.449219 5.074219 C 6.449219 5.0625 6.460938 5.050781 6.484375 5.050781 C 6.503906 5.050781 6.519531 5.0625 6.519531 5.074219 C 6.519531 5.089844 6.507812 5.097656 6.484375 5.097656 C 6.464844 5.101562 6.449219 5.089844 6.449219 5.074219 Z M 6.65625 5.464844 L 6.671875 5.425781 L 6.816406 5.425781 L 6.828125 5.464844 Z M 7.296875 5.257812 L 7.328125 5.289062 L 7.238281 5.363281 L 7.191406 5.347656 Z M 7.257812 5.234375 L 7.207031 5.21875 L 7.117188 5.292969 L 7.148438 5.324219 Z M 6.679688 5.261719 L 6.648438 5.292969 L 6.742188 5.367188 L 6.792969 5.351562 Z M 6.71875 5.238281 L 6.769531 5.222656 L 6.863281 5.300781 L 6.832031 5.332031 Z M 7.519531 5.21875 L 7.574219 5.230469 L 7.574219 5.324219 L 7.519531 5.335938 Z M 7.464844 5.21875 L 7.414062 5.230469 L 7.414062 5.324219 L 7.464844 5.335938 Z M 6.507812 5.21875 L 6.5625 5.230469 L 6.5625 5.324219 L 6.507812 5.339844 Z M 6.460938 5.21875 L 6.40625 5.230469 L 6.40625 5.324219 L 6.460938 5.335938 Z M 7.015625 5.128906 L 7.015625 5.203125 L 6.964844 5.203125 L 6.964844 5.128906 C 6.941406 5.125 6.917969 5.113281 6.914062 5.09375 L 6.785156 5.09375 L 6.785156 5.058594 L 6.914062 5.058594 C 6.921875 5.035156 6.957031 5.019531 6.992188 5.019531 C 7.027344 5.019531 7.058594 5.035156 7.070312 5.058594 L 7.195312 5.058594 L 7.195312 5.09375 L 7.070312 5.09375 C 7.058594 5.113281 7.039062 5.125 7.015625 5.128906 Z M 7.519531 5.128906 L 7.519531 5.25 L 7.46875 5.25 L 7.46875 5.128906 C 7.464844 5.128906 7.464844 5.128906 7.460938 5.128906 L 7.269531 5.28125 L 7.230469 5.261719 L 7.421875 5.101562 C 7.421875 5.097656 7.417969 5.097656 7.417969 5.09375 L 7.28125 5.09375 L 7.28125 5.058594 L 7.417969 5.058594 C 7.429688 5.035156 7.464844 5.019531 7.5 5.019531 C 7.546875 5.019531 7.582031 5.046875 7.582031 5.078125 C 7.578125 5.101562 7.554688 5.121094 7.519531 5.128906 Z M 6.515625 5.128906 L 6.707031 5.285156 L 6.746094 5.261719 L 6.554688 5.105469 C 6.558594 5.101562 6.5625 5.097656 6.5625 5.09375 L 6.703125 5.09375 L 6.703125 5.058594 L 6.5625 5.058594 C 6.550781 5.035156 6.519531 5.019531 6.484375 5.019531 C 6.4375 5.019531 6.402344 5.046875 6.402344 5.078125 C 6.402344 5.105469 6.421875 5.125 6.457031 5.132812 L 6.457031 5.253906 L 6.507812 5.253906 L 6.507812 5.128906 C 6.507812 5.128906 6.511719 5.128906 6.515625 5.128906 Z M 7.464844 5.46875 C 7.46875 5.460938 7.480469 5.457031 7.496094 5.457031 C 7.511719 5.457031 7.519531 5.460938 7.527344 5.46875 L 7.578125 5.46875 C 7.570312 5.449219 7.550781 5.433594 7.519531 5.425781 L 7.519531 5.308594 L 7.46875 5.308594 L 7.46875 5.425781 C 7.445312 5.433594 7.425781 5.445312 7.417969 5.464844 L 7.28125 5.464844 L 7.28125 5.46875 Z M 6.78125 5.46875 L 6.78125 5.464844 L 6.914062 5.464844 C 6.914062 5.460938 6.917969 5.457031 6.917969 5.457031 L 6.761719 5.328125 L 6.800781 5.304688 L 6.957031 5.429688 C 6.960938 5.429688 6.960938 5.425781 6.960938 5.425781 L 6.960938 5.261719 L 7.011719 5.261719 L 7.011719 5.425781 C 7.015625 5.425781 7.019531 5.425781 7.019531 5.429688 L 7.171875 5.304688 L 7.210938 5.328125 L 7.054688 5.453125 C 7.058594 5.457031 7.0625 5.464844 7.0625 5.464844 L 7.191406 5.464844 L 7.191406 5.46875 Z M 6.402344 5.46875 C 6.410156 5.449219 6.429688 5.433594 6.460938 5.425781 L 6.460938 5.308594 L 6.507812 5.308594 L 6.507812 5.425781 C 6.535156 5.433594 6.550781 5.445312 6.5625 5.464844 L 6.699219 5.464844 L 6.699219 5.46875 L 6.511719 5.46875 C 6.507812 5.460938 6.496094 5.457031 6.480469 5.457031 C 6.464844 5.457031 6.457031 5.460938 6.449219 5.46875 Z M 6.402344 5.46875 "
        ></path>
        <path
          style="
            fill: none;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(78.431373%, 70.196078%, 18.431373%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 18.307895 22.785 C 18.438158 22.875 18.579276 22.95 18.73125 22.995 L 18.622697 23.1 C 18.503289 23.055 18.383882 22.995 18.275329 22.92 Z M 18.383882 22.665 C 18.503289 22.755 18.655263 22.83 18.796382 22.875 L 18.828947 22.74 C 18.698684 22.695 18.579276 22.635 18.481579 22.56 Z M 17.895395 21.465 L 18.047368 21.495 C 18.047368 21.495 18.058224 21.735 18.047368 21.675 C 18.047368 21.615 18.069079 21.87 18.069079 21.87 L 17.917105 21.915 C 17.895395 21.84 17.895395 21.765 17.895395 21.69 Z M 17.775987 21.93 L 17.634868 21.9 L 17.613158 21.525 L 17.765132 21.48 L 17.765132 21.69 C 17.754276 21.765 17.765132 21.855 17.775987 21.93 Z M 17.960526 22.32 C 18.003947 22.275 18.058224 22.275 18.101645 22.305 C 18.145066 22.335 18.145066 22.395 18.1125 22.44 C 18.069079 22.485 18.014803 22.485 17.971382 22.455 C 17.927961 22.425 17.917105 22.365 17.960526 22.32 Z M 17.754276 21.585 L 17.754276 21.255 C 17.656579 21.225 17.591447 21.135 17.591447 21.045 C 17.591447 20.94 17.656579 20.865 17.754276 20.835 L 17.754276 20.37 L 17.895395 20.37 L 17.895395 20.835 C 17.960526 20.85 18.014803 20.895 18.036513 20.97 L 18.416447 20.97 L 18.416447 21.105 L 18.025658 21.105 C 18.014803 21.165 17.949671 21.21 17.895395 21.225 L 17.895395 21.57 Z M 18.492434 22.725 L 18.416447 22.845 C 18.297039 22.785 18.188487 22.68 18.101645 22.575 C 18.025658 22.605 17.938816 22.59 17.884539 22.545 C 17.775987 22.455 17.765132 22.335 17.862829 22.245 L 17.873684 22.23 C 17.808553 22.095 17.765132 21.96 17.765132 21.81 L 17.895395 21.81 C 17.90625 21.945 17.938816 22.065 17.993092 22.17 C 18.025658 22.17 18.069079 22.17 18.1125 22.185 L 18.470724 21.78 L 18.579276 21.87 L 18.221053 22.275 C 18.275329 22.335 18.275329 22.44 18.210197 22.515 C 18.297039 22.59 18.394737 22.665 18.492434 22.725 Z M 17.917105 19.695 L 18.449013 20.295 L 18.557566 20.205 L 18.025658 19.605 C 18.036513 19.59 18.047368 19.575 18.047368 19.56 L 18.438158 19.56 L 18.438158 19.425 L 18.047368 19.425 C 18.014803 19.335 17.927961 19.275 17.830263 19.275 C 17.7 19.275 17.602303 19.38 17.602303 19.5 C 17.602303 19.605 17.656579 19.68 17.754276 19.71 L 17.754276 20.175 L 17.895395 20.175 L 17.895395 19.695 C 17.895395 19.695 17.90625 19.695 17.917105 19.695 Z M 19.035197 21.15 C 19.035197 21.135 19.035197 21.12 19.024342 21.105 L 18.655263 21.105 L 18.655263 20.985 L 19.024342 20.985 C 19.024342 20.97 19.035197 20.955 19.035197 20.955 L 18.600987 20.46 L 18.709539 20.37 L 19.14375 20.85 C 19.154605 20.85 19.154605 20.835 19.154605 20.835 L 19.154605 20.205 L 19.295724 20.205 L 19.295724 20.835 C 19.306579 20.835 19.317434 20.835 19.317434 20.85 L 19.740789 20.37 L 19.849342 20.46 L 19.415132 20.94 C 19.425987 20.955 19.436842 20.97 19.436842 20.985 L 19.795066 20.985 L 19.795066 21.12 L 19.436842 21.12 C 19.425987 21.135 19.425987 21.15 19.415132 21.165 L 19.816776 21.615 L 19.708224 21.705 L 19.306579 21.255 C 19.295724 21.255 19.295724 21.255 19.284868 21.255 L 19.284868 22.02 L 19.154605 22.02 L 19.154605 21.255 C 19.14375 21.255 19.14375 21.255 19.132895 21.255 L 18.709539 21.705 L 18.600987 21.615 Z M 19.447697 22.935 C 19.55625 22.905 19.664803 22.875 19.773355 22.845 L 19.838487 22.965 C 19.719079 23.01 19.588816 23.055 19.458553 23.07 C 19.436842 23.175 19.35 23.235 19.241447 23.235 C 19.132895 23.235 19.035197 23.175 19.024342 23.07 C 18.883224 23.055 18.752961 23.025 18.622697 22.965 L 18.687829 22.845 C 18.796382 22.875 18.904934 22.92 19.035197 22.935 C 19.056908 22.875 19.100329 22.83 19.154605 22.815 L 19.154605 22.215 L 19.295724 22.215 L 19.295724 22.815 C 19.371711 22.83 19.425987 22.875 19.447697 22.935 Z M 20.554934 20.04 L 20.413816 20.085 L 20.413816 20.46 L 20.554934 20.505 Z M 17.895395 20.04 L 18.047368 20.085 L 18.047368 20.46 L 17.895395 20.505 Z M 17.765132 20.04 L 17.613158 20.085 L 17.613158 20.46 L 17.765132 20.505 Z M 20.153289 22.785 C 20.023026 22.875 19.881908 22.95 19.729934 22.995 L 19.838487 23.1 C 19.957895 23.055 20.077303 22.995 20.185855 22.92 Z M 20.077303 22.665 C 19.957895 22.755 19.805921 22.83 19.664803 22.875 L 19.632237 22.74 C 19.7625 22.695 19.881908 22.635 19.979605 22.56 Z M 19.306579 19.695 L 19.306579 19.98 L 19.165461 19.98 L 19.165461 19.695 C 19.100329 19.68 19.035197 19.635 19.024342 19.56 L 18.666118 19.56 L 18.666118 19.425 L 19.024342 19.425 C 19.046053 19.335 19.14375 19.275 19.241447 19.275 C 19.339145 19.275 19.425987 19.335 19.458553 19.425 L 19.805921 19.425 L 19.805921 19.56 L 19.458553 19.56 C 19.425987 19.635 19.371711 19.68 19.306579 19.695 Z M 20.706908 19.695 L 20.706908 20.16 L 20.565789 20.16 L 20.565789 19.695 C 20.554934 19.695 20.554934 19.695 20.544079 19.695 L 20.012171 20.28 L 19.903618 20.19 L 20.435526 19.59 C 20.435526 19.575 20.424671 19.575 20.424671 19.56 L 20.044737 19.56 L 20.044737 19.425 L 20.424671 19.425 C 20.457237 19.335 20.554934 19.275 20.652632 19.275 C 20.782895 19.275 20.880592 19.38 20.880592 19.5 C 20.869737 19.59 20.804605 19.665 20.706908 19.695 Z M 20.554934 21.465 L 20.413816 21.495 C 20.413816 21.495 20.402961 21.735 20.402961 21.675 C 20.402961 21.615 20.38125 21.87 20.38125 21.87 L 20.533224 21.915 C 20.544079 21.84 20.554934 21.765 20.554934 21.69 Z M 20.685197 21.93 L 20.837171 21.9 L 20.858882 21.525 L 20.706908 21.48 L 20.706908 21.69 C 20.706908 21.765 20.696053 21.855 20.685197 21.93 Z M 20.511513 22.32 C 20.478947 22.275 20.413816 22.275 20.370395 22.305 C 20.326974 22.335 20.316118 22.395 20.359539 22.44 C 20.402961 22.485 20.457237 22.485 20.500658 22.455 C 20.544079 22.425 20.544079 22.365 20.511513 22.32 Z M 20.706908 21.585 L 20.706908 21.255 C 20.804605 21.225 20.869737 21.135 20.869737 21.045 C 20.869737 20.94 20.804605 20.865 20.706908 20.835 L 20.706908 20.37 L 20.565789 20.37 L 20.565789 20.835 C 20.500658 20.85 20.446382 20.895 20.424671 20.97 L 20.044737 20.97 L 20.044737 21.105 L 20.424671 21.105 C 20.446382 21.165 20.500658 21.21 20.565789 21.225 L 20.565789 21.57 Z M 19.96875 22.725 L 20.044737 22.845 C 20.164145 22.785 20.272697 22.68 20.359539 22.575 C 20.424671 22.605 20.511513 22.59 20.576645 22.545 C 20.685197 22.455 20.685197 22.335 20.609211 22.245 L 20.598355 22.23 C 20.663487 22.095 20.696053 21.96 20.706908 21.81 L 20.565789 21.81 C 20.554934 21.945 20.533224 22.065 20.478947 22.17 C 20.435526 22.155 20.402961 22.17 20.359539 22.185 L 20.001316 21.78 L 19.892763 21.87 L 20.250987 22.275 C 20.196711 22.335 20.196711 22.44 20.261842 22.515 C 20.175 22.59 20.077303 22.665 19.96875 22.725 Z M 17.732566 21.045 C 17.732566 20.985 17.765132 20.955 17.830263 20.955 C 17.884539 20.955 17.927961 20.985 17.927961 21.045 C 17.927961 21.09 17.895395 21.135 17.830263 21.135 C 17.765132 21.135 17.732566 21.09 17.732566 21.045 Z M 18.394737 21.87 L 18.307895 21.75 L 18.568421 21.465 L 18.709539 21.525 Z M 18.503289 21.96 L 18.644408 22.02 L 18.904934 21.735 L 18.818092 21.615 Z M 19.675658 19.425 L 19.719079 19.29 L 20.120724 19.29 L 20.164145 19.425 Z M 19.675658 19.56 L 19.719079 19.695 L 20.120724 19.695 L 20.164145 19.56 Z M 19.132895 19.485 C 19.132895 19.44 19.165461 19.395 19.230592 19.395 C 19.284868 19.395 19.328289 19.44 19.328289 19.485 C 19.328289 19.545 19.284868 19.575 19.230592 19.575 C 19.176316 19.59 19.132895 19.545 19.132895 19.485 Z M 20.544079 19.485 C 20.544079 19.44 20.576645 19.395 20.641776 19.395 C 20.685197 19.395 20.739474 19.44 20.739474 19.485 C 20.739474 19.545 20.696053 19.575 20.641776 19.575 C 20.5875 19.59 20.544079 19.545 20.544079 19.485 Z M 19.165461 22.335 L 19.024342 22.305 L 19.024342 21.915 L 19.165461 21.885 Z M 19.306579 22.335 L 19.458553 22.305 L 19.458553 21.915 L 19.306579 21.885 Z M 19.14375 23.025 C 19.14375 22.965 19.176316 22.935 19.241447 22.935 C 19.284868 22.935 19.339145 22.965 19.339145 23.025 C 19.339145 23.07 19.295724 23.115 19.241447 23.115 C 19.187171 23.115 19.14375 23.07 19.14375 23.025 Z M 20.164145 21.105 L 20.120724 21.255 L 19.719079 21.255 L 19.675658 21.105 Z M 20.164145 20.985 L 20.120724 20.835 L 19.719079 20.835 L 19.675658 20.985 Z M 20.544079 21.045 C 20.544079 20.985 20.576645 20.955 20.641776 20.955 C 20.685197 20.955 20.739474 20.985 20.739474 21.045 C 20.739474 21.09 20.696053 21.135 20.641776 21.135 C 20.576645 21.135 20.544079 21.09 20.544079 21.045 Z M 18.785526 19.425 L 18.752961 19.29 L 18.351316 19.29 L 18.307895 19.425 Z M 18.785526 19.56 L 18.752961 19.695 L 18.351316 19.695 L 18.307895 19.56 Z M 17.732566 19.485 C 17.732566 19.44 17.765132 19.395 17.830263 19.395 C 17.884539 19.395 17.927961 19.44 17.927961 19.485 C 17.927961 19.545 17.895395 19.575 17.830263 19.575 C 17.775987 19.59 17.732566 19.545 17.732566 19.485 Z M 18.307895 21.105 L 18.351316 21.255 L 18.752961 21.255 L 18.785526 21.105 Z M 18.307895 20.985 L 18.351316 20.835 L 18.752961 20.835 L 18.785526 20.985 Z M 20.088158 20.19 L 20.175 20.31 L 19.925329 20.595 L 19.795066 20.535 Z M 19.979605 20.1 L 19.838487 20.04 L 19.588816 20.325 L 19.675658 20.445 Z M 18.373026 20.205 L 18.286184 20.325 L 18.546711 20.595 L 18.687829 20.535 Z M 18.481579 20.115 L 18.622697 20.055 L 18.883224 20.34 L 18.796382 20.46 Z M 20.066447 21.87 L 20.153289 21.75 L 19.892763 21.465 L 19.751645 21.525 Z M 19.957895 21.96 L 19.816776 22.02 L 19.55625 21.735 L 19.643092 21.615 Z M 20.706908 20.04 L 20.858882 20.085 L 20.858882 20.46 L 20.706908 20.505 Z M 19.306579 19.86 L 19.458553 19.905 L 19.458553 20.28 L 19.306579 20.325 Z M 19.154605 19.86 L 19.013487 19.905 L 19.013487 20.28 L 19.154605 20.325 Z M 19.154605 19.86 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(0%, 56.078431%, 43.529412%);
            fill-opacity: 1;
          "
          d="M 6.910156 5.480469 C 6.910156 5.449219 6.945312 5.421875 6.992188 5.421875 C 7.039062 5.421875 7.074219 5.449219 7.074219 5.480469 C 7.074219 5.511719 7.039062 5.535156 6.992188 5.535156 C 6.945312 5.535156 6.910156 5.511719 6.910156 5.480469 Z M 6.910156 5.480469 "
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.284868 15.375 L 19.284868 15.315 L 19.295724 15.285 C 19.295724 15.285 19.154605 15.3 19.089474 15.285 C 19.024342 15.255 18.959211 15.225 18.894079 15.18 C 18.818092 15.12 18.796382 15.09 18.752961 15.075 C 18.644408 15.06 18.546711 15.105 18.546711 15.105 C 18.546711 15.105 18.644408 15.135 18.698684 15.225 C 18.763816 15.3 18.828947 15.345 18.861513 15.345 C 18.904934 15.36 19.078618 15.345 19.132895 15.36 C 19.187171 15.36 19.284868 15.375 19.284868 15.375 Z M 19.284868 15.375 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(92.156863%, 44.313725%, 66.27451%);
            fill-opacity: 1;
          "
          d="M 7.238281 3.953125 C 7.238281 3.953125 7.238281 3.96875 7.238281 3.984375 C 7.242188 4 7.234375 4.011719 7.238281 4.019531 C 7.238281 4.027344 7.238281 4.035156 7.242188 4.039062 C 7.246094 4.042969 7.25 4.058594 7.25 4.058594 C 7.25 4.058594 7.238281 4.054688 7.230469 4.046875 C 7.21875 4.042969 7.210938 4.035156 7.210938 4.035156 C 7.210938 4.035156 7.214844 4.050781 7.214844 4.058594 C 7.214844 4.066406 7.222656 4.078125 7.230469 4.085938 C 7.238281 4.09375 7.253906 4.105469 7.261719 4.113281 C 7.265625 4.128906 7.265625 4.148438 7.265625 4.148438 C 7.265625 4.148438 7.25 4.132812 7.238281 4.128906 C 7.230469 4.128906 7.199219 4.117188 7.199219 4.117188 C 7.199219 4.117188 7.226562 4.136719 7.226562 4.152344 C 7.226562 4.167969 7.214844 4.183594 7.214844 4.183594 C 7.214844 4.183594 7.203125 4.167969 7.191406 4.160156 C 7.175781 4.152344 7.15625 4.140625 7.15625 4.140625 C 7.15625 4.140625 7.171875 4.167969 7.171875 4.183594 C 7.171875 4.199219 7.167969 4.238281 7.167969 4.238281 C 7.167969 4.238281 7.15625 4.222656 7.144531 4.214844 C 7.132812 4.207031 7.117188 4.203125 7.109375 4.199219 C 7.105469 4.191406 7.125 4.210938 7.128906 4.222656 C 7.132812 4.234375 7.140625 4.277344 7.1875 4.324219 C 7.214844 4.355469 7.257812 4.410156 7.351562 4.390625 C 7.445312 4.371094 7.410156 4.28125 7.390625 4.238281 C 7.375 4.199219 7.363281 4.152344 7.363281 4.132812 C 7.363281 4.117188 7.378906 4.066406 7.375 4.058594 C 7.375 4.050781 7.371094 4.015625 7.378906 3.988281 C 7.390625 3.957031 7.402344 3.945312 7.410156 3.933594 C 7.417969 3.921875 7.417969 3.917969 7.421875 3.90625 C 7.425781 3.894531 7.425781 3.875 7.425781 3.875 C 7.425781 3.875 7.445312 3.898438 7.449219 3.90625 C 7.453125 3.914062 7.453125 3.941406 7.453125 3.941406 C 7.453125 3.941406 7.457031 3.917969 7.480469 3.902344 C 7.507812 3.890625 7.539062 3.878906 7.546875 3.871094 C 7.554688 3.863281 7.554688 3.863281 7.554688 3.863281 C 7.554688 3.863281 7.554688 3.902344 7.539062 3.917969 C 7.527344 3.929688 7.484375 3.964844 7.484375 3.964844 C 7.484375 3.964844 7.507812 3.960938 7.519531 3.960938 C 7.535156 3.960938 7.546875 3.960938 7.546875 3.960938 C 7.546875 3.960938 7.527344 3.972656 7.503906 3.996094 C 7.476562 4.023438 7.488281 4.027344 7.46875 4.046875 C 7.453125 4.066406 7.4375 4.066406 7.417969 4.082031 C 7.382812 4.097656 7.402344 4.175781 7.40625 4.1875 C 7.410156 4.199219 7.464844 4.292969 7.464844 4.316406 C 7.464844 4.339844 7.472656 4.386719 7.417969 4.417969 C 7.382812 4.441406 7.328125 4.441406 7.316406 4.445312 C 7.300781 4.449219 7.277344 4.46875 7.277344 4.507812 C 7.277344 4.546875 7.292969 4.550781 7.3125 4.5625 C 7.328125 4.574219 7.347656 4.566406 7.351562 4.574219 C 7.355469 4.582031 7.359375 4.589844 7.367188 4.589844 C 7.375 4.597656 7.375 4.601562 7.375 4.609375 C 7.371094 4.617188 7.34375 4.636719 7.335938 4.652344 C 7.328125 4.664062 7.3125 4.699219 7.3125 4.707031 C 7.3125 4.710938 7.308594 4.726562 7.320312 4.734375 C 7.320312 4.734375 7.347656 4.757812 7.328125 4.761719 C 7.316406 4.765625 7.304688 4.757812 7.296875 4.757812 C 7.28125 4.761719 7.273438 4.769531 7.269531 4.769531 C 7.257812 4.765625 7.257812 4.761719 7.257812 4.753906 C 7.257812 4.742188 7.257812 4.738281 7.253906 4.738281 C 7.246094 4.738281 7.242188 4.742188 7.242188 4.746094 C 7.242188 4.753906 7.242188 4.769531 7.238281 4.769531 C 7.230469 4.769531 7.21875 4.757812 7.210938 4.753906 C 7.203125 4.753906 7.1875 4.75 7.1875 4.746094 C 7.1875 4.738281 7.195312 4.726562 7.207031 4.722656 C 7.21875 4.722656 7.230469 4.71875 7.222656 4.714844 C 7.214844 4.707031 7.207031 4.707031 7.199219 4.714844 C 7.191406 4.71875 7.175781 4.714844 7.179688 4.707031 C 7.179688 4.699219 7.183594 4.691406 7.183594 4.691406 C 7.183594 4.6875 7.167969 4.679688 7.1875 4.671875 C 7.203125 4.664062 7.210938 4.675781 7.230469 4.675781 C 7.246094 4.671875 7.253906 4.667969 7.261719 4.660156 C 7.269531 4.652344 7.269531 4.636719 7.253906 4.628906 C 7.242188 4.617188 7.230469 4.617188 7.226562 4.609375 C 7.222656 4.605469 7.214844 4.589844 7.214844 4.589844 C 7.214844 4.589844 7.21875 4.613281 7.214844 4.621094 C 7.210938 4.621094 7.214844 4.636719 7.214844 4.636719 C 7.214844 4.636719 7.203125 4.628906 7.191406 4.621094 C 7.183594 4.613281 7.175781 4.589844 7.175781 4.589844 C 7.175781 4.589844 7.175781 4.613281 7.175781 4.621094 C 7.175781 4.628906 7.191406 4.636719 7.183594 4.636719 C 7.179688 4.640625 7.15625 4.621094 7.148438 4.621094 C 7.144531 4.617188 7.128906 4.605469 7.121094 4.597656 C 7.113281 4.585938 7.105469 4.570312 7.105469 4.566406 C 7.101562 4.558594 7.101562 4.535156 7.101562 4.53125 C 7.109375 4.523438 7.117188 4.507812 7.117188 4.507812 L 7.074219 4.507812 C 7.054688 4.507812 7.035156 4.503906 7.027344 4.511719 C 7.019531 4.523438 7.023438 4.546875 7.035156 4.574219 C 7.046875 4.605469 7.054688 4.621094 7.050781 4.625 C 7.046875 4.628906 7.03125 4.644531 7.027344 4.644531 C 7.019531 4.644531 7.007812 4.644531 7 4.644531 C 6.992188 4.640625 6.980469 4.636719 6.960938 4.636719 C 6.9375 4.636719 6.925781 4.636719 6.917969 4.636719 C 6.914062 4.636719 6.894531 4.628906 6.882812 4.628906 C 6.875 4.632812 6.859375 4.636719 6.867188 4.644531 C 6.871094 4.660156 6.859375 4.660156 6.851562 4.660156 C 6.84375 4.660156 6.835938 4.660156 6.824219 4.65625 C 6.8125 4.652344 6.792969 4.65625 6.796875 4.644531 C 6.800781 4.636719 6.804688 4.636719 6.808594 4.628906 C 6.8125 4.621094 6.816406 4.621094 6.808594 4.621094 C 6.800781 4.621094 6.792969 4.621094 6.785156 4.621094 C 6.78125 4.625 6.773438 4.632812 6.765625 4.628906 C 6.757812 4.628906 6.75 4.621094 6.75 4.605469 C 6.75 4.59375 6.730469 4.582031 6.75 4.582031 C 6.769531 4.582031 6.792969 4.589844 6.796875 4.582031 C 6.800781 4.574219 6.800781 4.574219 6.789062 4.566406 C 6.78125 4.5625 6.769531 4.558594 6.78125 4.550781 C 6.792969 4.542969 6.796875 4.542969 6.800781 4.539062 C 6.804688 4.535156 6.8125 4.519531 6.824219 4.527344 C 6.839844 4.53125 6.824219 4.542969 6.839844 4.558594 C 6.859375 4.574219 6.871094 4.578125 6.902344 4.574219 C 6.933594 4.574219 6.941406 4.570312 6.941406 4.5625 C 6.941406 4.558594 6.9375 4.542969 6.9375 4.539062 C 6.9375 4.535156 6.941406 4.519531 6.941406 4.519531 C 6.941406 4.519531 6.925781 4.523438 6.921875 4.53125 C 6.917969 4.53125 6.90625 4.542969 6.90625 4.542969 C 6.90625 4.542969 6.902344 4.527344 6.902344 4.519531 C 6.902344 4.511719 6.90625 4.5 6.90625 4.5 C 6.90625 4.496094 6.898438 4.480469 6.898438 4.480469 C 6.898438 4.480469 6.894531 4.496094 6.890625 4.5 C 6.886719 4.503906 6.886719 4.523438 6.886719 4.523438 C 6.886719 4.523438 6.867188 4.511719 6.871094 4.488281 C 6.875 4.472656 6.871094 4.449219 6.875 4.445312 C 6.882812 4.4375 6.898438 4.410156 6.9375 4.410156 C 6.976562 4.410156 7.007812 4.410156 7.019531 4.410156 C 7.035156 4.410156 7.082031 4.402344 7.082031 4.402344 C 7.082031 4.402344 6.992188 4.367188 6.972656 4.355469 C 6.953125 4.347656 6.917969 4.320312 6.914062 4.308594 C 6.902344 4.300781 6.894531 4.277344 6.894531 4.277344 C 6.894531 4.277344 6.878906 4.277344 6.863281 4.28125 C 6.847656 4.285156 6.832031 4.296875 6.824219 4.300781 C 6.820312 4.308594 6.804688 4.324219 6.804688 4.324219 C 6.804688 4.324219 6.808594 4.304688 6.808594 4.300781 C 6.808594 4.292969 6.804688 4.28125 6.804688 4.28125 C 6.804688 4.28125 6.792969 4.308594 6.777344 4.320312 C 6.753906 4.332031 6.734375 4.347656 6.734375 4.347656 C 6.734375 4.347656 6.734375 4.332031 6.734375 4.328125 C 6.734375 4.324219 6.738281 4.308594 6.738281 4.308594 C 6.738281 4.308594 6.726562 4.324219 6.703125 4.324219 C 6.683594 4.328125 6.648438 4.328125 6.644531 4.339844 C 6.644531 4.347656 6.652344 4.363281 6.644531 4.371094 C 6.644531 4.378906 6.628906 4.378906 6.628906 4.378906 C 6.628906 4.378906 6.617188 4.371094 6.601562 4.371094 C 6.59375 4.371094 6.582031 4.375 6.582031 4.375 C 6.582031 4.375 6.570312 4.367188 6.574219 4.359375 C 6.578125 4.355469 6.597656 4.34375 6.589844 4.339844 C 6.585938 4.339844 6.570312 4.339844 6.5625 4.347656 C 6.554688 4.351562 6.539062 4.351562 6.539062 4.339844 C 6.539062 4.332031 6.546875 4.324219 6.539062 4.316406 C 6.535156 4.308594 6.539062 4.308594 6.546875 4.304688 C 6.550781 4.300781 6.578125 4.304688 6.582031 4.300781 C 6.585938 4.292969 6.574219 4.289062 6.554688 4.285156 C 6.539062 4.285156 6.53125 4.277344 6.539062 4.269531 C 6.550781 4.261719 6.550781 4.261719 6.554688 4.253906 C 6.558594 4.25 6.5625 4.238281 6.578125 4.246094 C 6.59375 4.25 6.59375 4.261719 6.605469 4.265625 C 6.625 4.269531 6.664062 4.261719 6.671875 4.261719 C 6.679688 4.257812 6.707031 4.242188 6.71875 4.238281 C 6.730469 4.238281 6.765625 4.214844 6.765625 4.214844 C 6.765625 4.214844 6.742188 4.207031 6.734375 4.199219 C 6.726562 4.191406 6.707031 4.175781 6.699219 4.175781 C 6.691406 4.171875 6.652344 4.160156 6.644531 4.160156 C 6.628906 4.160156 6.59375 4.152344 6.59375 4.152344 C 6.59375 4.152344 6.609375 4.144531 6.617188 4.144531 C 6.625 4.140625 6.636719 4.128906 6.644531 4.132812 C 6.648438 4.132812 6.648438 4.132812 6.648438 4.132812 C 6.648438 4.132812 6.613281 4.132812 6.605469 4.128906 C 6.597656 4.128906 6.578125 4.117188 6.566406 4.117188 C 6.558594 4.117188 6.542969 4.121094 6.542969 4.121094 C 6.542969 4.121094 6.5625 4.109375 6.585938 4.105469 C 6.601562 4.105469 6.617188 4.105469 6.617188 4.105469 C 6.617188 4.105469 6.589844 4.097656 6.582031 4.089844 C 6.574219 4.082031 6.566406 4.074219 6.5625 4.066406 C 6.558594 4.0625 6.554688 4.054688 6.546875 4.054688 C 6.535156 4.054688 6.519531 4.0625 6.507812 4.0625 C 6.5 4.0625 6.492188 4.058594 6.492188 4.046875 C 6.492188 4.035156 6.492188 4.042969 6.488281 4.035156 C 6.484375 4.027344 6.46875 4.015625 6.484375 4.011719 C 6.5 4.011719 6.523438 4.015625 6.527344 4.011719 C 6.53125 4.007812 6.511719 3.996094 6.503906 3.992188 C 6.492188 3.988281 6.472656 3.980469 6.484375 3.976562 C 6.496094 3.972656 6.503906 3.96875 6.507812 3.964844 C 6.515625 3.957031 6.519531 3.941406 6.53125 3.949219 C 6.542969 3.953125 6.554688 3.976562 6.566406 3.972656 C 6.574219 3.972656 6.578125 3.957031 6.574219 3.949219 C 6.570312 3.941406 6.574219 3.929688 6.582031 3.929688 C 6.589844 3.929688 6.597656 3.941406 6.609375 3.941406 C 6.625 3.941406 6.644531 3.9375 6.644531 3.945312 C 6.644531 3.953125 6.632812 3.960938 6.625 3.96875 C 6.613281 3.976562 6.609375 3.992188 6.617188 4.003906 C 6.625 4.011719 6.640625 4.027344 6.652344 4.035156 C 6.667969 4.039062 6.691406 4.042969 6.707031 4.050781 C 6.722656 4.058594 6.761719 4.082031 6.773438 4.082031 C 6.78125 4.085938 6.796875 4.089844 6.796875 4.089844 C 6.796875 4.089844 6.8125 4.085938 6.828125 4.085938 C 6.847656 4.085938 6.894531 4.089844 6.914062 4.082031 C 6.929688 4.078125 6.953125 4.070312 6.945312 4.058594 C 6.9375 4.046875 6.902344 4.035156 6.90625 4.027344 C 6.910156 4.019531 6.921875 4.019531 6.945312 4.019531 C 6.964844 4.019531 7 4.019531 7.007812 3.996094 C 7.011719 3.972656 7.011719 3.960938 6.980469 3.957031 C 6.949219 3.949219 6.921875 3.949219 6.917969 3.933594 C 6.914062 3.914062 6.910156 3.910156 6.917969 3.90625 C 6.921875 3.902344 6.933594 3.898438 6.960938 3.898438 C 6.984375 3.894531 7.007812 3.894531 7.015625 3.894531 C 7.023438 3.886719 7.027344 3.878906 7.035156 3.871094 C 7.046875 3.867188 7.082031 3.863281 7.082031 3.863281 C 7.082031 3.863281 7.125 3.878906 7.164062 3.902344 C 7.203125 3.925781 7.238281 3.953125 7.238281 3.953125 Z M 7.238281 3.953125 "
        ></path>
        <path
          style="
            fill: none;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.925329 15.18 C 19.925329 15.18 19.925329 15.24 19.925329 15.3 C 19.936184 15.36 19.914474 15.405 19.925329 15.435 C 19.925329 15.465 19.925329 15.495 19.936184 15.51 C 19.947039 15.525 19.957895 15.585 19.957895 15.585 C 19.957895 15.585 19.925329 15.57 19.903618 15.54 C 19.871053 15.525 19.849342 15.495 19.849342 15.495 C 19.849342 15.495 19.860197 15.555 19.860197 15.585 C 19.860197 15.615 19.881908 15.66 19.903618 15.69 C 19.925329 15.72 19.96875 15.765 19.990461 15.795 C 20.001316 15.855 20.001316 15.93 20.001316 15.93 C 20.001316 15.93 19.957895 15.87 19.925329 15.855 C 19.903618 15.855 19.816776 15.81 19.816776 15.81 C 19.816776 15.81 19.892763 15.885 19.892763 15.945 C 19.892763 16.005 19.860197 16.065 19.860197 16.065 C 19.860197 16.065 19.827632 16.005 19.795066 15.975 C 19.751645 15.945 19.697368 15.9 19.697368 15.9 C 19.697368 15.9 19.740789 16.005 19.740789 16.065 C 19.740789 16.125 19.729934 16.275 19.729934 16.275 C 19.729934 16.275 19.697368 16.215 19.664803 16.185 C 19.632237 16.155 19.588816 16.14 19.567105 16.125 C 19.55625 16.095 19.610526 16.17 19.621382 16.215 C 19.632237 16.26 19.653947 16.425 19.784211 16.605 C 19.860197 16.725 19.979605 16.935 20.240132 16.86 C 20.500658 16.785 20.402961 16.44 20.348684 16.275 C 20.305263 16.125 20.272697 15.945 20.272697 15.87 C 20.272697 15.81 20.316118 15.615 20.305263 15.585 C 20.305263 15.555 20.294408 15.42 20.316118 15.315 C 20.348684 15.195 20.38125 15.15 20.402961 15.105 C 20.424671 15.06 20.424671 15.045 20.435526 15 C 20.446382 14.955 20.446382 14.88 20.446382 14.88 C 20.446382 14.88 20.500658 14.97 20.511513 15 C 20.522368 15.03 20.522368 15.135 20.522368 15.135 C 20.522368 15.135 20.533224 15.045 20.598355 14.985 C 20.674342 14.94 20.761184 14.895 20.782895 14.865 C 20.804605 14.835 20.804605 14.835 20.804605 14.835 C 20.804605 14.835 20.804605 14.985 20.761184 15.045 C 20.728618 15.09 20.609211 15.225 20.609211 15.225 C 20.609211 15.225 20.674342 15.21 20.706908 15.21 C 20.750329 15.21 20.782895 15.21 20.782895 15.21 C 20.782895 15.21 20.728618 15.255 20.663487 15.345 C 20.5875 15.45 20.620066 15.465 20.565789 15.54 C 20.522368 15.615 20.478947 15.615 20.424671 15.675 C 20.326974 15.735 20.38125 16.035 20.392105 16.08 C 20.402961 16.125 20.554934 16.485 20.554934 16.575 C 20.554934 16.665 20.576645 16.845 20.424671 16.965 C 20.326974 17.055 20.175 17.055 20.142434 17.07 C 20.099013 17.085 20.033882 17.16 20.033882 17.31 C 20.033882 17.46 20.077303 17.475 20.131579 17.52 C 20.175 17.565 20.229276 17.535 20.240132 17.565 C 20.250987 17.595 20.261842 17.625 20.283553 17.625 C 20.305263 17.655 20.305263 17.67 20.305263 17.7 C 20.294408 17.73 20.218421 17.805 20.196711 17.865 C 20.175 17.91 20.131579 18.045 20.131579 18.075 C 20.131579 18.09 20.120724 18.15 20.153289 18.18 C 20.153289 18.18 20.229276 18.27 20.175 18.285 C 20.142434 18.3 20.109868 18.27 20.088158 18.27 C 20.044737 18.285 20.023026 18.315 20.012171 18.315 C 19.979605 18.3 19.979605 18.285 19.979605 18.255 C 19.979605 18.21 19.979605 18.195 19.96875 18.195 C 19.947039 18.195 19.936184 18.21 19.936184 18.225 C 19.936184 18.255 19.936184 18.315 19.925329 18.315 C 19.903618 18.315 19.871053 18.27 19.849342 18.255 C 19.827632 18.255 19.784211 18.24 19.784211 18.225 C 19.784211 18.195 19.805921 18.15 19.838487 18.135 C 19.871053 18.135 19.903618 18.12 19.881908 18.105 C 19.860197 18.075 19.838487 18.075 19.816776 18.105 C 19.795066 18.12 19.751645 18.105 19.7625 18.075 C 19.7625 18.045 19.773355 18.015 19.773355 18.015 C 19.773355 18 19.729934 17.97 19.784211 17.94 C 19.827632 17.91 19.849342 17.955 19.903618 17.955 C 19.947039 17.94 19.96875 17.925 19.990461 17.895 C 20.012171 17.865 20.012171 17.805 19.96875 17.775 C 19.936184 17.73 19.903618 17.73 19.892763 17.7 C 19.881908 17.685 19.860197 17.625 19.860197 17.625 C 19.860197 17.625 19.871053 17.715 19.860197 17.745 C 19.849342 17.745 19.860197 17.805 19.860197 17.805 C 19.860197 17.805 19.827632 17.775 19.795066 17.745 C 19.773355 17.715 19.751645 17.625 19.751645 17.625 C 19.751645 17.625 19.751645 17.715 19.751645 17.745 C 19.751645 17.775 19.795066 17.805 19.773355 17.805 C 19.7625 17.82 19.697368 17.745 19.675658 17.745 C 19.664803 17.73 19.621382 17.685 19.599671 17.655 C 19.577961 17.61 19.55625 17.55 19.55625 17.535 C 19.545395 17.505 19.545395 17.415 19.545395 17.4 C 19.567105 17.37 19.588816 17.31 19.588816 17.31 L 19.469408 17.31 C 19.415132 17.31 19.360855 17.295 19.339145 17.325 C 19.317434 17.37 19.328289 17.46 19.360855 17.565 C 19.393421 17.685 19.415132 17.745 19.404276 17.76 C 19.393421 17.775 19.35 17.835 19.339145 17.835 C 19.317434 17.835 19.284868 17.835 19.263158 17.835 C 19.241447 17.82 19.208882 17.805 19.154605 17.805 C 19.089474 17.805 19.056908 17.805 19.035197 17.805 C 19.024342 17.805 18.970066 17.775 18.9375 17.775 C 18.915789 17.79 18.872368 17.805 18.894079 17.835 C 18.904934 17.895 18.872368 17.895 18.850658 17.895 C 18.828947 17.895 18.807237 17.895 18.774671 17.88 C 18.742105 17.865 18.687829 17.88 18.698684 17.835 C 18.709539 17.805 18.720395 17.805 18.73125 17.775 C 18.742105 17.745 18.752961 17.745 18.73125 17.745 C 18.709539 17.745 18.687829 17.745 18.666118 17.745 C 18.655263 17.76 18.633553 17.79 18.611842 17.775 C 18.590132 17.775 18.568421 17.745 18.568421 17.685 C 18.568421 17.64 18.514145 17.595 18.568421 17.595 C 18.622697 17.595 18.687829 17.625 18.698684 17.595 C 18.709539 17.565 18.709539 17.565 18.676974 17.535 C 18.655263 17.52 18.622697 17.505 18.655263 17.475 C 18.687829 17.445 18.698684 17.445 18.709539 17.43 C 18.720395 17.415 18.742105 17.355 18.774671 17.385 C 18.818092 17.4 18.774671 17.445 18.818092 17.505 C 18.872368 17.565 18.904934 17.58 18.991776 17.565 C 19.078618 17.565 19.100329 17.55 19.100329 17.52 C 19.100329 17.505 19.089474 17.445 19.089474 17.43 C 19.089474 17.415 19.100329 17.355 19.100329 17.355 C 19.100329 17.355 19.056908 17.37 19.046053 17.4 C 19.035197 17.4 19.002632 17.445 19.002632 17.445 C 19.002632 17.445 18.991776 17.385 18.991776 17.355 C 18.991776 17.325 19.002632 17.28 19.002632 17.28 C 19.002632 17.265 18.980921 17.205 18.980921 17.205 C 18.980921 17.205 18.970066 17.265 18.959211 17.28 C 18.948355 17.295 18.948355 17.37 18.948355 17.37 C 18.948355 17.37 18.894079 17.325 18.904934 17.235 C 18.915789 17.175 18.904934 17.085 18.915789 17.07 C 18.9375 17.04 18.980921 16.935 19.089474 16.935 C 19.198026 16.935 19.284868 16.935 19.317434 16.935 C 19.360855 16.935 19.491118 16.905 19.491118 16.905 C 19.491118 16.905 19.241447 16.77 19.187171 16.725 C 19.132895 16.695 19.035197 16.59 19.024342 16.545 C 18.991776 16.515 18.970066 16.425 18.970066 16.425 C 18.970066 16.425 18.926645 16.425 18.883224 16.44 C 18.839803 16.455 18.796382 16.5 18.774671 16.515 C 18.763816 16.545 18.720395 16.605 18.720395 16.605 C 18.720395 16.605 18.73125 16.53 18.73125 16.515 C 18.73125 16.485 18.720395 16.44 18.720395 16.44 C 18.720395 16.44 18.687829 16.545 18.644408 16.59 C 18.579276 16.635 18.525 16.695 18.525 16.695 C 18.525 16.695 18.525 16.635 18.525 16.62 C 18.525 16.605 18.535855 16.545 18.535855 16.545 C 18.535855 16.545 18.503289 16.605 18.438158 16.605 C 18.383882 16.62 18.286184 16.62 18.275329 16.665 C 18.275329 16.695 18.297039 16.755 18.275329 16.785 C 18.275329 16.815 18.231908 16.815 18.231908 16.815 C 18.231908 16.815 18.199342 16.785 18.155921 16.785 C 18.134211 16.785 18.101645 16.8 18.101645 16.8 C 18.101645 16.8 18.069079 16.77 18.079934 16.74 C 18.090789 16.725 18.145066 16.68 18.123355 16.665 C 18.1125 16.665 18.069079 16.665 18.047368 16.695 C 18.025658 16.71 17.982237 16.71 17.982237 16.665 C 17.982237 16.635 18.003947 16.605 17.982237 16.575 C 17.971382 16.545 17.982237 16.545 18.003947 16.53 C 18.014803 16.515 18.090789 16.53 18.101645 16.515 C 18.1125 16.485 18.079934 16.47 18.025658 16.455 C 17.982237 16.455 17.960526 16.425 17.982237 16.395 C 18.014803 16.365 18.014803 16.365 18.025658 16.335 C 18.036513 16.32 18.047368 16.275 18.090789 16.305 C 18.134211 16.32 18.134211 16.365 18.166776 16.38 C 18.221053 16.395 18.329605 16.365 18.351316 16.365 C 18.373026 16.35 18.449013 16.29 18.481579 16.275 C 18.514145 16.275 18.611842 16.185 18.611842 16.185 C 18.611842 16.185 18.546711 16.155 18.525 16.125 C 18.503289 16.095 18.449013 16.035 18.427303 16.035 C 18.405592 16.02 18.297039 15.975 18.275329 15.975 C 18.231908 15.975 18.134211 15.945 18.134211 15.945 C 18.134211 15.945 18.177632 15.915 18.199342 15.915 C 18.221053 15.9 18.253618 15.855 18.275329 15.87 C 18.286184 15.87 18.286184 15.87 18.286184 15.87 C 18.286184 15.87 18.188487 15.87 18.166776 15.855 C 18.145066 15.855 18.090789 15.81 18.058224 15.81 C 18.036513 15.81 17.993092 15.825 17.993092 15.825 C 17.993092 15.825 18.047368 15.78 18.1125 15.765 C 18.155921 15.765 18.199342 15.765 18.199342 15.765 C 18.199342 15.765 18.123355 15.735 18.101645 15.705 C 18.079934 15.675 18.058224 15.645 18.047368 15.615 C 18.036513 15.6 18.025658 15.57 18.003947 15.57 C 17.971382 15.57 17.927961 15.6 17.895395 15.6 C 17.873684 15.6 17.851974 15.585 17.851974 15.54 C 17.851974 15.495 17.851974 15.525 17.841118 15.495 C 17.830263 15.465 17.786842 15.42 17.830263 15.405 C 17.873684 15.405 17.938816 15.42 17.949671 15.405 C 17.960526 15.39 17.90625 15.345 17.884539 15.33 C 17.851974 15.315 17.797697 15.285 17.830263 15.27 C 17.862829 15.255 17.884539 15.24 17.895395 15.225 C 17.917105 15.195 17.927961 15.135 17.960526 15.165 C 17.993092 15.18 18.025658 15.27 18.058224 15.255 C 18.079934 15.255 18.090789 15.195 18.079934 15.165 C 18.069079 15.135 18.079934 15.09 18.101645 15.09 C 18.123355 15.09 18.145066 15.135 18.177632 15.135 C 18.221053 15.135 18.275329 15.12 18.275329 15.15 C 18.275329 15.18 18.242763 15.21 18.221053 15.24 C 18.188487 15.27 18.177632 15.33 18.199342 15.375 C 18.221053 15.405 18.264474 15.465 18.297039 15.495 C 18.340461 15.51 18.405592 15.525 18.449013 15.555 C 18.492434 15.585 18.600987 15.675 18.633553 15.675 C 18.655263 15.69 18.698684 15.705 18.698684 15.705 C 18.698684 15.705 18.742105 15.69 18.785526 15.69 C 18.839803 15.69 18.970066 15.705 19.024342 15.675 C 19.067763 15.66 19.132895 15.63 19.111184 15.585 C 19.089474 15.54 18.991776 15.495 19.002632 15.465 C 19.013487 15.435 19.046053 15.435 19.111184 15.435 C 19.165461 15.435 19.263158 15.435 19.284868 15.345 C 19.295724 15.255 19.295724 15.21 19.208882 15.195 C 19.122039 15.165 19.046053 15.165 19.035197 15.105 C 19.024342 15.03 19.013487 15.015 19.035197 15 C 19.046053 14.985 19.078618 14.97 19.154605 14.97 C 19.219737 14.955 19.284868 14.955 19.306579 14.955 C 19.328289 14.925 19.339145 14.895 19.360855 14.865 C 19.393421 14.85 19.491118 14.835 19.491118 14.835 C 19.491118 14.835 19.610526 14.895 19.719079 14.985 C 19.827632 15.075 19.925329 15.18 19.925329 15.18 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.046053 15.12 C 19.046053 15.12 19.035197 15.075 19.035197 15.075 C 19.035197 15.06 19.024342 15.045 19.024342 15.045 C 19.024342 15.045 19.089474 15.045 19.089474 15.075 C 19.089474 15.09 19.067763 15.09 19.056908 15.105 C 19.056908 15.105 19.046053 15.12 19.046053 15.12 Z M 19.046053 15.12 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 1;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.393421 15 L 19.382566 14.955 C 19.382566 14.955 19.436842 14.955 19.469408 14.985 C 19.523684 15.015 19.545395 15.075 19.545395 15.075 C 19.545395 15.075 19.501974 15.045 19.480263 15.045 C 19.480263 15.045 19.458553 15.045 19.436842 15.045 C 19.415132 15.045 19.415132 15.03 19.415132 15.015 C 19.415132 15.015 19.415132 14.985 19.415132 14.985 Z M 19.393421 15 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill: none;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.849342 15.51 C 19.849342 15.51 19.816776 15.465 19.805921 15.465 C 19.795066 15.45 19.795066 15.42 19.795066 15.42 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 18.1125 15.105 C 18.1125 15.105 18.145066 15.135 18.177632 15.135 C 18.210197 15.135 18.242763 15.135 18.253618 15.135 C 18.253618 15.135 18.264474 15.075 18.264474 15.045 C 18.242763 14.955 18.145066 14.925 18.145066 14.925 C 18.145066 14.925 18.177632 14.985 18.155921 15.015 C 18.145066 15.075 18.1125 15.105 18.1125 15.105 Z M 18.1125 15.105 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 17.917105 15.195 C 17.917105 15.195 17.884539 15.135 17.808553 15.135 C 17.732566 15.135 17.678289 15.195 17.678289 15.195 C 17.678289 15.195 17.765132 15.195 17.775987 15.21 C 17.808553 15.225 17.819408 15.285 17.819408 15.285 C 17.819408 15.285 17.873684 15.255 17.884539 15.225 C 17.895395 15.225 17.917105 15.195 17.917105 15.195 Z M 17.917105 15.195 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 17.830263 15.45 C 17.830263 15.45 17.765132 15.465 17.732566 15.495 C 17.689145 15.54 17.7 15.615 17.7 15.615 C 17.7 15.615 17.743421 15.57 17.775987 15.57 C 17.819408 15.57 17.884539 15.585 17.884539 15.585 C 17.884539 15.585 17.862829 15.525 17.862829 15.51 C 17.862829 15.495 17.830263 15.45 17.830263 15.45 Z M 17.830263 15.45 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.046053 15.435 L 19.078618 15.405 L 19.111184 15.435 Z M 19.046053 15.435 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.122039 15.435 L 19.154605 15.405 L 19.187171 15.435 Z M 19.122039 15.435 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.089474 15.165 L 19.154605 15.195 L 19.100329 15.225 Z M 19.089474 15.165 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.165461 15.195 L 19.230592 15.195 L 19.187171 15.24 Z M 19.165461 15.195 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill: none;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 18.959211 16.41 C 18.959211 16.41 19.046053 16.365 19.078618 16.35 C 19.14375 16.32 19.176316 16.26 19.176316 16.26 M 18.622697 16.185 C 18.622697 16.185 18.655263 16.11 18.698684 16.095 C 18.742105 16.065 18.785526 16.035 18.796382 16.02 C 18.807237 16.02 18.883224 15.975 18.883224 15.975 M 18.709539 15.72 C 18.709539 15.72 18.644408 15.735 18.622697 15.78 C 18.590132 15.825 18.590132 15.87 18.590132 15.87 C 18.590132 15.87 18.655263 15.825 18.720395 15.84 C 18.785526 15.855 18.796382 15.87 18.828947 15.87 C 18.861513 15.87 18.9375 15.84 18.9375 15.84 C 18.9375 15.84 18.883224 15.915 18.894079 15.96 C 18.904934 16.005 18.904934 16.035 18.904934 16.065 C 18.904934 16.125 18.850658 16.2 18.850658 16.2 C 18.850658 16.2 18.883224 16.185 18.9375 16.17 C 19.002632 16.155 19.046053 16.125 19.089474 16.095 C 19.122039 16.08 19.165461 16.02 19.165461 16.02 C 19.165461 16.02 19.154605 16.095 19.165461 16.14 C 19.176316 16.185 19.187171 16.275 19.187171 16.275 C 19.187171 16.275 19.230592 16.245 19.263158 16.23 C 19.284868 16.215 19.317434 16.2 19.339145 16.17 C 19.35 16.155 19.371711 16.08 19.371711 16.08 C 19.371711 16.08 19.382566 16.155 19.404276 16.185 C 19.415132 16.23 19.458553 16.335 19.458553 16.335 C 19.458553 16.335 19.480263 16.275 19.512829 16.245 C 19.545395 16.215 19.567105 16.17 19.567105 16.155 C 19.567105 16.125 19.55625 16.08 19.55625 16.08 L 19.588816 16.155 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 18.036513 16.305 C 18.036513 16.305 18.003947 16.26 17.938816 16.275 C 17.884539 16.275 17.841118 16.35 17.841118 16.35 C 17.841118 16.35 17.895395 16.335 17.917105 16.335 C 17.949671 16.35 17.971382 16.38 17.971382 16.38 C 17.971382 16.38 18.003947 16.365 18.014803 16.335 C 18.025658 16.335 18.036513 16.305 18.036513 16.305 Z M 18.036513 16.305 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 17.971382 16.545 C 17.971382 16.545 17.917105 16.545 17.873684 16.575 C 17.830263 16.62 17.819408 16.695 17.819408 16.695 C 17.819408 16.695 17.862829 16.65 17.895395 16.665 C 17.927961 16.665 17.971382 16.68 17.971382 16.68 C 17.971382 16.68 17.982237 16.635 17.982237 16.635 C 17.993092 16.59 17.971382 16.545 17.971382 16.545 Z M 17.971382 16.545 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
          "
          d="M 6.578125 4.371094 C 6.578125 4.371094 6.578125 4.386719 6.589844 4.398438 C 6.597656 4.410156 6.621094 4.410156 6.621094 4.410156 C 6.621094 4.410156 6.613281 4.402344 6.613281 4.394531 C 6.609375 4.386719 6.625 4.378906 6.625 4.378906 C 6.625 4.378906 6.613281 4.371094 6.601562 4.371094 C 6.59375 4.371094 6.578125 4.371094 6.578125 4.371094 Z M 6.578125 4.371094 "
        ></path>
        <path
          style="
            fill: none;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 18.090789 16.785 C 18.090789 16.785 18.090789 16.845 18.123355 16.89 C 18.145066 16.935 18.210197 16.935 18.210197 16.935 C 18.210197 16.935 18.188487 16.905 18.188487 16.875 C 18.177632 16.845 18.221053 16.815 18.221053 16.815 C 18.221053 16.815 18.188487 16.785 18.155921 16.785 C 18.134211 16.785 18.090789 16.785 18.090789 16.785 Z M 19.491118 16.89 C 19.491118 16.89 19.664803 16.995 19.664803 17.085 C 19.664803 17.175 19.567105 17.28 19.567105 17.28 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 18.709539 17.37 C 18.709539 17.37 18.666118 17.325 18.611842 17.325 C 18.546711 17.325 18.492434 17.385 18.492434 17.385 C 18.492434 17.385 18.557566 17.37 18.579276 17.4 C 18.600987 17.43 18.622697 17.46 18.622697 17.46 C 18.622697 17.46 18.655263 17.445 18.666118 17.43 C 18.676974 17.415 18.709539 17.37 18.709539 17.37 Z M 18.709539 17.37 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 18.525 17.61 C 18.525 17.61 18.449013 17.595 18.405592 17.64 C 18.373026 17.685 18.373026 17.745 18.373026 17.745 C 18.373026 17.745 18.416447 17.7 18.459868 17.7 C 18.503289 17.7 18.546711 17.73 18.546711 17.73 C 18.546711 17.73 18.535855 17.685 18.535855 17.655 C 18.535855 17.64 18.525 17.61 18.525 17.61 Z M 18.525 17.61 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 18.698684 17.865 C 18.698684 17.865 18.655263 17.91 18.687829 17.955 C 18.720395 18 18.774671 18.015 18.774671 18.015 C 18.774671 18.015 18.763816 17.985 18.774671 17.955 C 18.774671 17.925 18.828947 17.88 18.828947 17.88 Z M 18.698684 17.865 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.740789 17.955 C 19.740789 17.955 19.664803 17.94 19.632237 17.97 C 19.588816 17.985 19.55625 18.09 19.55625 18.09 C 19.55625 18.09 19.621382 18.045 19.664803 18.045 C 19.708224 18.045 19.751645 18.06 19.751645 18.06 C 19.751645 18.06 19.7625 18.015 19.751645 17.985 C 19.751645 17.985 19.740789 17.955 19.740789 17.955 Z M 19.740789 17.955 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.773355 18.21 C 19.773355 18.21 19.719079 18.255 19.740789 18.315 C 19.7625 18.345 19.795066 18.405 19.795066 18.405 C 19.795066 18.405 19.795066 18.33 19.805921 18.315 C 19.838487 18.285 19.903618 18.285 19.903618 18.285 C 19.903618 18.285 19.849342 18.24 19.838487 18.24 C 19.827632 18.24 19.773355 18.21 19.773355 18.21 Z M 19.773355 18.21 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(85.490196%, 27.058824%, 27.45098%);
            fill-opacity: 1;
            stroke-width: 0.0326;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 20.033882 18.285 C 20.033882 18.285 20.001316 18.36 20.044737 18.405 C 20.099013 18.435 20.142434 18.45 20.142434 18.45 C 20.142434 18.45 20.099013 18.375 20.109868 18.345 C 20.120724 18.315 20.164145 18.285 20.164145 18.285 C 20.164145 18.285 20.099013 18.27 20.088158 18.27 C 20.088158 18.255 20.033882 18.285 20.033882 18.285 Z M 20.033882 18.285 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(100%, 84.313725%, 56.862745%);
            fill-opacity: 1;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 17.363487 22.935 C 17.526316 22.995 17.624013 23.115 17.624013 23.28 C 17.624013 23.475 17.428618 23.625 17.178947 23.625 C 16.929276 23.625 16.733882 23.475 16.733882 23.28 C 16.733882 23.13 16.809868 22.965 16.994408 22.95 C 16.994408 22.95 16.983553 22.935 16.972697 22.905 C 16.950987 22.89 16.918421 22.845 16.918421 22.845 C 16.918421 22.845 16.994408 22.845 17.016118 22.845 C 17.059539 22.875 17.08125 22.89 17.08125 22.89 C 17.08125 22.89 17.102961 22.845 17.124671 22.83 C 17.135526 22.8 17.178947 22.785 17.178947 22.785 C 17.178947 22.785 17.222368 22.815 17.233224 22.845 C 17.244079 22.86 17.254934 22.89 17.254934 22.89 C 17.254934 22.89 17.2875 22.86 17.320066 22.845 C 17.352632 22.845 17.385197 22.83 17.385197 22.83 C 17.385197 22.83 17.385197 22.875 17.374342 22.89 C 17.363487 22.905 17.363487 22.935 17.363487 22.935 Z M 17.363487 22.935 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 56.078431%, 43.529412%);
            fill-opacity: 1;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 17.135526 23.85 C 17.135526 23.85 16.809868 23.625 16.657895 23.595 C 16.473355 23.55 16.267105 23.58 16.180263 23.58 C 16.180263 23.58 16.288816 23.655 16.332237 23.7 C 16.375658 23.745 16.527632 23.835 16.625329 23.865 C 16.885855 23.925 17.135526 23.85 17.135526 23.85 Z M 17.135526 23.85 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 56.078431%, 43.529412%);
            fill-opacity: 1;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 17.244079 23.865 C 17.244079 23.865 17.450329 23.655 17.678289 23.625 C 17.938816 23.58 18.123355 23.64 18.221053 23.67 C 18.221053 23.67 18.145066 23.715 18.090789 23.745 C 18.036513 23.775 17.927961 23.865 17.743421 23.865 C 17.558882 23.865 17.363487 23.85 17.320066 23.865 C 17.2875 23.865 17.244079 23.865 17.244079 23.865 Z M 17.244079 23.865 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(67.45098%, 12.156863%, 13.72549%);
            fill-opacity: 1;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 17.168092 23.595 C 17.092105 23.505 17.026974 23.4 17.026974 23.28 C 17.026974 23.16 17.08125 23.055 17.168092 22.965 C 17.254934 23.055 17.298355 23.16 17.298355 23.28 C 17.309211 23.4 17.254934 23.505 17.168092 23.595 Z M 17.168092 23.595 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 56.078431%, 43.529412%);
            fill-opacity: 1;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 17.092105 24.045 C 17.092105 24.045 17.135526 23.91 17.146382 23.805 C 17.146382 23.715 17.135526 23.625 17.135526 23.625 L 17.211513 23.625 C 17.211513 23.625 17.244079 23.715 17.244079 23.805 C 17.244079 23.88 17.233224 24 17.233224 24 C 17.233224 24 17.178947 24.015 17.168092 24.015 C 17.135526 24.03 17.092105 24.045 17.092105 24.045 Z M 17.092105 24.045 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
          "
          d="M 5.636719 4.042969 L 5.75 4.042969 Z M 5.429688 3.925781 L 5.535156 3.925781 Z M 5.214844 4.042969 L 5.324219 4.042969 Z M 5.480469 3.980469 L 5.480469 3.941406 Z M 5.480469 4.058594 L 5.480469 4.019531 Z M 5.480469 4.179688 L 5.480469 4.140625 Z M 5.480469 4.261719 L 5.480469 4.21875 Z M 5.480469 4.421875 L 5.480469 4.378906 Z M 5.480469 4.339844 L 5.480469 4.300781 Z M 5.480469 4.507812 L 5.480469 4.464844 Z M 5.695312 4.058594 L 5.695312 4.097656 Z M 5.59375 4.140625 L 5.59375 4.179688 Z M 5.800781 4.140625 L 5.800781 4.179688 Z M 5.75 4.179688 L 5.75 4.222656 Z M 5.636719 4.179688 L 5.636719 4.222656 Z M 5.535156 4.179688 L 5.535156 4.222656 Z M 5.59375 4.222656 L 5.59375 4.261719 Z M 5.695312 4.222656 L 5.695312 4.261719 Z M 5.800781 4.222656 L 5.800781 4.261719 Z M 5.75 4.261719 L 5.75 4.300781 Z M 5.636719 4.261719 L 5.636719 4.300781 Z M 5.535156 4.261719 L 5.535156 4.300781 Z M 5.59375 4.300781 L 5.59375 4.339844 Z M 5.535156 4.339844 L 5.535156 4.382812 Z M 5.535156 4.421875 L 5.535156 4.460938 Z M 5.59375 4.507812 L 5.59375 4.464844 Z M 5.535156 4.507812 L 5.535156 4.550781 Z M 5.636719 4.507812 L 5.636719 4.550781 Z M 5.75 4.507812 L 5.75 4.550781 Z M 5.59375 4.582031 L 5.59375 4.546875 Z M 5.636719 4.582031 L 5.636719 4.628906 Z M 5.855469 4.628906 L 5.855469 4.582031 Z M 5.75 4.628906 L 5.75 4.582031 Z M 5.695312 4.507812 L 5.695312 4.464844 Z M 5.695312 4.582031 L 5.695312 4.546875 Z M 5.695312 4.667969 L 5.695312 4.628906 Z M 5.695312 4.75 L 5.695312 4.707031 Z M 5.75 4.710938 L 5.75 4.667969 Z M 5.855469 4.667969 L 5.855469 4.710938 Z M 5.800781 4.667969 L 5.800781 4.628906 Z M 5.800781 4.75 L 5.800781 4.707031 Z M 5.800781 4.011719 L 5.59375 4.011719 Z M 5.75 4.058594 L 5.636719 4.058594 Z M 5.273438 4.058594 L 5.273438 4.097656 Z M 5.375 4.140625 L 5.375 4.179688 Z M 5.164062 4.140625 L 5.164062 4.179688 Z M 5.214844 4.179688 L 5.214844 4.222656 Z M 5.324219 4.179688 L 5.324219 4.222656 Z M 5.429688 4.179688 L 5.429688 4.222656 Z M 5.375 4.222656 L 5.375 4.261719 Z M 5.273438 4.222656 L 5.273438 4.261719 Z M 5.164062 4.222656 L 5.164062 4.261719 Z M 5.214844 4.261719 L 5.214844 4.300781 Z M 5.324219 4.261719 L 5.324219 4.300781 Z M 5.429688 4.261719 L 5.429688 4.300781 Z M 5.375 4.300781 L 5.375 4.339844 Z M 5.429688 4.339844 L 5.429688 4.382812 Z M 5.429688 4.421875 L 5.429688 4.460938 Z M 5.375 4.507812 L 5.375 4.464844 Z M 5.429688 4.507812 L 5.429688 4.550781 Z M 5.324219 4.507812 L 5.324219 4.550781 Z M 5.214844 4.507812 L 5.214844 4.550781 Z M 5.375 4.582031 L 5.375 4.546875 Z M 5.324219 4.582031 L 5.324219 4.628906 Z M 5.109375 4.628906 L 5.109375 4.582031 Z M 5.214844 4.628906 L 5.214844 4.582031 Z M 5.273438 4.507812 L 5.273438 4.464844 Z M 5.273438 4.582031 L 5.273438 4.546875 Z M 5.273438 4.667969 L 5.273438 4.628906 Z M 5.273438 4.75 L 5.273438 4.707031 Z M 5.214844 4.710938 L 5.214844 4.667969 Z M 5.109375 4.667969 L 5.109375 4.710938 Z M 5.164062 4.667969 L 5.164062 4.628906 Z M 5.164062 4.75 L 5.164062 4.707031 Z M 5.164062 4.011719 L 5.371094 4.011719 Z M 5.214844 4.058594 L 5.324219 4.058594 Z M 5.375 3.886719 L 5.59375 3.886719 Z M 5.429688 3.9375 L 5.535156 3.9375 Z M 5.429688 3.980469 L 5.535156 3.980469 Z M 5.429688 4.019531 L 5.535156 4.019531 Z M 5.429688 4.058594 L 5.535156 4.058594 Z M 5.214844 4.097656 L 5.75 4.097656 Z M 5.109375 4.140625 L 5.855469 4.140625 Z M 5.109375 4.179688 L 5.855469 4.179688 Z M 5.109375 4.222656 L 5.855469 4.222656 Z M 5.109375 4.261719 L 5.855469 4.261719 Z M 5.164062 4.300781 L 5.796875 4.300781 Z M 5.164062 4.339844 L 5.796875 4.339844 Z M 5.164062 4.382812 L 5.796875 4.382812 Z M 5.164062 4.421875 L 5.796875 4.421875 Z M 5.164062 4.464844 L 5.796875 4.464844 Z M 5.164062 4.507812 L 5.796875 4.507812 Z M 5.164062 4.550781 L 5.796875 4.550781 Z M 5.050781 4.582031 L 5.910156 4.582031 Z M 5.050781 4.628906 L 5.910156 4.628906 Z M 5.050781 4.667969 L 5.910156 4.667969 Z M 5.050781 4.710938 L 5.910156 4.710938 Z M 5.050781 4.75 L 5.910156 4.75 Z M 5.242188 3.984375 L 5.214844 3.984375 L 5.214844 3.964844 L 5.164062 3.964844 L 5.164062 4.042969 L 5.214844 4.042969 L 5.214844 4.097656 L 5.109375 4.097656 L 5.109375 4.261719 L 5.164062 4.261719 L 5.164062 4.582031 L 5.050781 4.582031 L 5.050781 4.75 L 5.910156 4.75 L 5.910156 4.582031 L 5.796875 4.582031 L 5.796875 4.261719 L 5.855469 4.261719 L 5.855469 4.097656 L 5.75 4.097656 L 5.75 4.042969 L 5.800781 4.042969 L 5.800781 3.964844 L 5.75 3.964844 L 5.75 3.984375 L 5.722656 3.984375 L 5.722656 3.964844 L 5.671875 3.964844 L 5.671875 3.984375 L 5.636719 3.984375 L 5.636719 3.964844 L 5.585938 3.964844 L 5.585938 4.042969 L 5.636719 4.042969 L 5.636719 4.097656 L 5.53125 4.097656 L 5.53125 3.921875 L 5.585938 3.921875 L 5.585938 3.839844 L 5.53125 3.839844 L 5.53125 3.863281 L 5.5 3.863281 L 5.5 3.839844 L 5.453125 3.839844 L 5.453125 3.863281 L 5.429688 3.863281 L 5.429688 3.839844 L 5.375 3.839844 L 5.375 3.921875 L 5.429688 3.921875 L 5.429688 4.097656 L 5.324219 4.097656 L 5.324219 4.042969 L 5.375 4.042969 L 5.375 3.964844 L 5.324219 3.964844 L 5.324219 3.984375 L 5.296875 3.984375 L 5.296875 3.964844 L 5.242188 3.964844 Z M 5.242188 3.984375 "
        ></path>
        <path
          style="
            fill: none;
            stroke-width: 0.0386;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 15.474671 15.525 L 15.789474 15.525 M 14.899342 15.075 L 15.192434 15.075 M 14.302303 15.525 L 14.60625 15.525 M 15.040461 15.285 L 15.040461 15.135 M 15.040461 15.585 L 15.040461 15.435 M 15.040461 16.05 L 15.040461 15.9 M 15.040461 16.365 L 15.040461 16.2 M 15.040461 16.98 L 15.040461 16.815 M 15.040461 16.665 L 15.040461 16.515 M 15.040461 17.31 L 15.040461 17.145 M 15.6375 15.585 L 15.6375 15.735 M 15.355263 15.9 L 15.355263 16.05 M 15.930592 15.9 L 15.930592 16.05 M 15.789474 16.05 L 15.789474 16.215 M 15.474671 16.05 L 15.474671 16.215 M 15.192434 16.05 L 15.192434 16.215 M 15.355263 16.215 L 15.355263 16.365 M 15.6375 16.215 L 15.6375 16.365 M 15.930592 16.215 L 15.930592 16.365 M 15.789474 16.365 L 15.789474 16.515 M 15.474671 16.365 L 15.474671 16.515 M 15.192434 16.365 L 15.192434 16.515 M 15.355263 16.515 L 15.355263 16.665 M 15.192434 16.665 L 15.192434 16.83 M 15.192434 16.98 L 15.192434 17.13 M 15.355263 17.31 L 15.355263 17.145 M 15.192434 17.31 L 15.192434 17.475 M 15.474671 17.31 L 15.474671 17.475 M 15.789474 17.31 L 15.789474 17.475 M 15.355263 17.595 L 15.355263 17.46 M 15.474671 17.595 L 15.474671 17.775 M 16.082566 17.775 L 16.082566 17.595 M 15.789474 17.775 L 15.789474 17.595 M 15.6375 17.31 L 15.6375 17.145 M 15.6375 17.595 L 15.6375 17.46 M 15.6375 17.925 L 15.6375 17.775 M 15.6375 18.24 L 15.6375 18.075 M 15.789474 18.09 L 15.789474 17.925 M 16.082566 17.925 L 16.082566 18.09 M 15.930592 17.925 L 15.930592 17.775 M 15.930592 18.24 L 15.930592 18.075 M 15.930592 15.405 L 15.355263 15.405 M 15.789474 15.585 L 15.474671 15.585 M 14.465132 15.585 L 14.465132 15.735 M 14.747368 15.9 L 14.747368 16.05 M 14.161184 15.9 L 14.161184 16.05 M 14.302303 16.05 L 14.302303 16.215 M 14.60625 16.05 L 14.60625 16.215 M 14.899342 16.05 L 14.899342 16.215 M 14.747368 16.215 L 14.747368 16.365 M 14.465132 16.215 L 14.465132 16.365 M 14.161184 16.215 L 14.161184 16.365 M 14.302303 16.365 L 14.302303 16.515 M 14.60625 16.365 L 14.60625 16.515 M 14.899342 16.365 L 14.899342 16.515 M 14.747368 16.515 L 14.747368 16.665 M 14.899342 16.665 L 14.899342 16.83 M 14.899342 16.98 L 14.899342 17.13 M 14.747368 17.31 L 14.747368 17.145 M 14.899342 17.31 L 14.899342 17.475 M 14.60625 17.31 L 14.60625 17.475 M 14.302303 17.31 L 14.302303 17.475 M 14.747368 17.595 L 14.747368 17.46 M 14.60625 17.595 L 14.60625 17.775 M 14.009211 17.775 L 14.009211 17.595 M 14.302303 17.775 L 14.302303 17.595 M 14.465132 17.31 L 14.465132 17.145 M 14.465132 17.595 L 14.465132 17.46 M 14.465132 17.925 L 14.465132 17.775 M 14.465132 18.24 L 14.465132 18.075 M 14.302303 18.09 L 14.302303 17.925 M 14.009211 17.925 L 14.009211 18.09 M 14.161184 17.925 L 14.161184 17.775 M 14.161184 18.24 L 14.161184 18.075 M 14.161184 15.405 L 14.736513 15.405 M 14.302303 15.585 L 14.60625 15.585 M 14.747368 14.925 L 15.355263 14.925 M 14.899342 15.12 L 15.192434 15.12 M 14.899342 15.285 L 15.192434 15.285 M 14.899342 15.435 L 15.192434 15.435 M 14.899342 15.585 L 15.192434 15.585 M 14.302303 15.735 L 15.789474 15.735 M 14.009211 15.9 L 16.082566 15.9 M 14.009211 16.05 L 16.082566 16.05 M 14.009211 16.215 L 16.082566 16.215 M 14.009211 16.365 L 16.082566 16.365 M 14.161184 16.515 L 15.919737 16.515 M 14.161184 16.665 L 15.919737 16.665 M 14.161184 16.83 L 15.919737 16.83 M 14.161184 16.98 L 15.919737 16.98 M 14.161184 17.145 L 15.919737 17.145 M 14.161184 17.31 L 15.919737 17.31 M 14.161184 17.475 L 15.919737 17.475 M 13.846382 17.595 L 16.234539 17.595 M 13.846382 17.775 L 16.234539 17.775 M 13.846382 17.925 L 16.234539 17.925 M 13.846382 18.09 L 16.234539 18.09 M 13.846382 18.24 L 16.234539 18.24 M 14.378289 15.3 L 14.302303 15.3 L 14.302303 15.225 L 14.161184 15.225 L 14.161184 15.525 L 14.302303 15.525 L 14.302303 15.735 L 14.009211 15.735 L 14.009211 16.365 L 14.161184 16.365 L 14.161184 17.595 L 13.846382 17.595 L 13.846382 18.24 L 16.234539 18.24 L 16.234539 17.595 L 15.919737 17.595 L 15.919737 16.365 L 16.082566 16.365 L 16.082566 15.735 L 15.789474 15.735 L 15.789474 15.525 L 15.930592 15.525 L 15.930592 15.225 L 15.789474 15.225 L 15.789474 15.3 L 15.713487 15.3 L 15.713487 15.225 L 15.572368 15.225 L 15.572368 15.3 L 15.474671 15.3 L 15.474671 15.225 L 15.333553 15.225 L 15.333553 15.525 L 15.474671 15.525 L 15.474671 15.735 L 15.181579 15.735 L 15.181579 15.06 L 15.333553 15.06 L 15.333553 14.745 L 15.181579 14.745 L 15.181579 14.835 L 15.094737 14.835 L 15.094737 14.745 L 14.964474 14.745 L 14.964474 14.835 L 14.899342 14.835 L 14.899342 14.745 L 14.747368 14.745 L 14.747368 15.06 L 14.899342 15.06 L 14.899342 15.735 L 14.60625 15.735 L 14.60625 15.525 L 14.747368 15.525 L 14.747368 15.225 L 14.60625 15.225 L 14.60625 15.3 L 14.530263 15.3 L 14.530263 15.225 L 14.378289 15.225 Z M 14.378289 15.3 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0386;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 15.442105 18.24 L 15.442105 17.835 C 15.442105 17.745 15.398684 17.52 15.029605 17.52 C 14.682237 17.52 14.638816 17.745 14.638816 17.835 L 14.638816 18.24 Z M 15.442105 18.24 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0386;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 14.779934 17.865 L 14.595395 17.835 C 14.595395 17.76 14.60625 17.655 14.671382 17.61 L 14.845066 17.745 C 14.823355 17.76 14.779934 17.82 14.779934 17.865 Z M 14.779934 17.865 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0386;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 15.311842 17.865 L 15.496382 17.835 C 15.496382 17.76 15.474671 17.655 15.420395 17.61 L 15.246711 17.745 C 15.268421 17.76 15.311842 17.82 15.311842 17.865 Z M 15.311842 17.865 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0386;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 15.105592 17.655 L 15.214145 17.49 C 15.170724 17.475 15.094737 17.445 15.040461 17.445 C 14.997039 17.445 14.921053 17.475 14.888487 17.49 L 14.986184 17.655 Z M 15.105592 17.655 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0386;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 14.747368 17.175 L 14.747368 16.755 C 14.747368 16.635 14.671382 16.545 14.541118 16.545 C 14.410855 16.545 14.334868 16.635 14.334868 16.755 L 14.334868 17.175 Z M 14.747368 17.175 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0386;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 15.355263 17.175 L 15.355263 16.755 C 15.355263 16.635 15.43125 16.545 15.561513 16.545 C 15.702632 16.545 15.767763 16.635 15.767763 16.755 L 15.767763 17.175 Z M 15.355263 17.175 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0386;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 15.192434 16.125 L 15.225 15.735 L 14.855921 15.735 L 14.877632 16.125 Z M 15.192434 16.125 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0386;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 15.474671 16.125 L 15.442105 15.735 L 15.832895 15.735 L 15.789474 16.125 Z M 15.474671 16.125 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0386;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 14.60625 16.125 L 14.627961 15.735 L 14.258882 15.735 L 14.302303 16.125 Z M 14.60625 16.125 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(22.745098%, 34.117647%, 65.490196%);
            fill-opacity: 1;
          "
          d="M 5.578125 4.75 L 5.578125 4.660156 C 5.578125 4.644531 5.5625 4.601562 5.480469 4.601562 C 5.40625 4.601562 5.390625 4.644531 5.390625 4.660156 L 5.390625 4.753906 L 5.578125 4.753906 Z M 5.578125 4.75 "
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(22.745098%, 34.117647%, 65.490196%);
            fill-opacity: 1;
          "
          d="M 5.363281 4.464844 L 5.363281 4.367188 C 5.363281 4.339844 5.339844 4.316406 5.300781 4.316406 C 5.261719 4.316406 5.238281 4.34375 5.238281 4.367188 L 5.238281 4.464844 Z M 5.363281 4.464844 "
        ></path>
        <path
          style="
            stroke: none;
            fill-rule: nonzero;
            fill: rgb(22.745098%, 34.117647%, 65.490196%);
            fill-opacity: 1;
          "
          d="M 5.605469 4.464844 L 5.605469 4.367188 C 5.605469 4.339844 5.628906 4.316406 5.667969 4.316406 C 5.707031 4.316406 5.730469 4.34375 5.730469 4.367188 L 5.730469 4.464844 Z M 5.605469 4.464844 "
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.871053 14.82 L 19.849342 14.82 C 19.849342 14.82 19.838487 14.835 19.827632 14.85 C 19.805921 14.865 19.784211 14.865 19.7625 14.865 C 19.751645 14.85 19.751645 14.835 19.751645 14.835 C 19.740789 14.835 19.719079 14.835 19.708224 14.835 C 19.686513 14.82 19.675658 14.79 19.697368 14.76 C 19.697368 14.76 19.708224 14.745 19.708224 14.745 L 19.708224 14.715 L 19.675658 14.73 L 19.664803 14.745 C 19.653947 14.775 19.621382 14.775 19.610526 14.76 C 19.599671 14.745 19.599671 14.745 19.599671 14.745 C 19.599671 14.745 19.588816 14.745 19.588816 14.745 C 19.545395 14.76 19.534539 14.655 19.534539 14.64 L 19.523684 14.655 C 19.523684 14.655 19.534539 14.715 19.534539 14.775 C 19.523684 14.82 19.512829 14.865 19.512829 14.865 C 19.567105 14.895 19.664803 14.94 19.7625 15.015 C 19.849342 15.075 19.925329 15.165 19.957895 15.21 C 19.957895 15.21 20.012171 15.18 20.055592 15.165 C 20.109868 15.15 20.175 15.15 20.175 15.15 L 20.185855 15.135 C 20.164145 15.135 20.055592 15.135 20.055592 15.09 C 20.055592 15.075 20.066447 15.075 20.066447 15.075 C 20.066447 15.075 20.044737 15.075 20.044737 15.06 C 20.033882 15.045 20.033882 15.015 20.044737 15 L 20.066447 14.985 L 20.066447 14.955 L 20.044737 14.955 C 20.044737 14.955 20.033882 14.97 20.033882 14.97 C 20.012171 14.985 19.979605 14.985 19.957895 14.97 C 19.947039 14.955 19.947039 14.955 19.947039 14.925 C 19.936184 14.925 19.925329 14.925 19.914474 14.925 C 19.892763 14.925 19.881908 14.895 19.903618 14.865 C 19.914474 14.85 19.925329 14.835 19.925329 14.835 Z M 19.871053 14.82 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 1;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.686513 14.88 C 19.686513 14.865 19.697368 14.865 19.708224 14.88 C 19.719079 14.88 19.719079 14.895 19.708224 14.895 C 19.708224 14.895 19.697368 14.895 19.686513 14.895 C 19.675658 14.895 19.675658 14.88 19.686513 14.88 Z M 19.686513 14.88 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 1;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.773355 14.94 L 19.740789 14.925 C 19.740789 14.925 19.729934 14.91 19.740789 14.91 C 19.740789 14.91 19.751645 14.91 19.751645 14.91 L 19.784211 14.925 L 19.805921 14.955 C 19.805921 14.955 19.816776 14.955 19.805921 14.955 C 19.805921 14.955 19.795066 14.955 19.795066 14.955 Z M 19.773355 14.94 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 1;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.621382 14.835 L 19.599671 14.835 C 19.588816 14.835 19.588816 14.82 19.588816 14.82 C 19.588816 14.82 19.599671 14.82 19.599671 14.82 L 19.621382 14.835 L 19.643092 14.835 C 19.643092 14.835 19.653947 14.85 19.653947 14.85 C 19.653947 14.85 19.643092 14.85 19.643092 14.85 Z M 19.621382 14.835 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 1;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.534539 14.79 C 19.534539 14.775 19.545395 14.775 19.545395 14.79 C 19.55625 14.805 19.55625 14.805 19.545395 14.805 C 19.545395 14.805 19.545395 14.805 19.534539 14.805 C 19.534539 14.805 19.534539 14.79 19.534539 14.79 Z M 19.534539 14.79 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 1;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.849342 15.015 C 19.849342 15.015 19.849342 15 19.849342 14.985 C 19.838487 14.985 19.827632 14.985 19.827632 14.985 C 19.827632 14.985 19.827632 15 19.827632 15.015 C 19.827632 15.015 19.849342 15.015 19.849342 15.015 Z M 19.849342 15.015 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 1;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.903618 15.06 L 19.925329 15.075 L 19.925329 15.045 L 19.903618 15.03 L 19.881908 15.03 L 19.881908 15.045 Z M 19.903618 15.06 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(0%, 0%, 0%);
            fill-opacity: 1;
            stroke-width: 1;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.979605 15.135 C 19.979605 15.135 19.979605 15.12 19.979605 15.105 C 19.96875 15.105 19.957895 15.105 19.957895 15.105 C 19.957895 15.105 19.957895 15.12 19.957895 15.135 C 19.96875 15.135 19.979605 15.135 19.979605 15.135 Z M 19.979605 15.135 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.751645 14.625 L 19.697368 14.625 L 19.686513 14.7 L 19.697368 14.715 L 19.708224 14.715 L 19.773355 14.67 Z M 19.751645 14.625 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.621382 14.655 L 19.610526 14.715 L 19.697368 14.715 L 19.697368 14.7 L 19.664803 14.64 Z M 19.621382 14.655 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.784211 14.745 L 19.729934 14.775 L 19.686513 14.715 L 19.686513 14.7 L 19.697368 14.7 L 19.784211 14.715 Z M 19.784211 14.745 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.675658 14.7 C 19.686513 14.685 19.697368 14.685 19.708224 14.685 C 19.719079 14.7 19.729934 14.715 19.719079 14.715 C 19.708224 14.73 19.697368 14.73 19.686513 14.73 C 19.664803 14.715 19.664803 14.715 19.675658 14.7 Z M 19.675658 14.7 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.491118 14.625 C 19.491118 14.625 19.480263 14.58 19.469408 14.565 C 19.458553 14.535 19.436842 14.52 19.436842 14.52 C 19.436842 14.52 19.480263 14.505 19.512829 14.535 C 19.545395 14.565 19.512829 14.595 19.512829 14.595 C 19.512829 14.595 19.501974 14.625 19.491118 14.625 Z M 19.491118 14.625 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.577961 14.655 L 19.545395 14.685 L 19.491118 14.625 L 19.501974 14.61 L 19.567105 14.595 Z M 19.577961 14.655 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.491118 14.625 C 19.491118 14.61 19.501974 14.595 19.512829 14.595 C 19.523684 14.595 19.523684 14.625 19.523684 14.625 C 19.523684 14.64 19.512829 14.655 19.501974 14.655 C 19.480263 14.64 19.480263 14.625 19.491118 14.625 Z M 19.491118 14.625 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.936184 14.745 L 19.892763 14.745 L 19.871053 14.805 L 19.871053 14.82 L 19.892763 14.82 L 19.957895 14.79 Z M 19.936184 14.745 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.795066 14.76 L 19.795066 14.805 L 19.871053 14.835 L 19.881908 14.82 L 19.881908 14.805 L 19.849342 14.745 Z M 19.795066 14.76 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.947039 14.865 L 19.903618 14.895 L 19.871053 14.835 L 19.871053 14.805 L 19.881908 14.805 L 19.947039 14.835 Z M 19.947039 14.865 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.849342 14.805 C 19.860197 14.805 19.871053 14.805 19.881908 14.805 C 19.892763 14.82 19.892763 14.835 19.881908 14.835 C 19.871053 14.85 19.860197 14.85 19.849342 14.835 C 19.849342 14.835 19.849342 14.82 19.849342 14.805 Z M 19.849342 14.805 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 20.109868 14.895 L 20.109868 14.94 L 20.044737 14.97 L 20.033882 14.955 L 20.055592 14.88 Z M 20.109868 14.895 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 20.088158 15.03 L 20.044737 15.045 L 20.023026 14.97 L 20.023026 14.955 L 20.044737 14.955 L 20.109868 14.985 Z M 20.088158 15.03 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 19.96875 14.895 L 19.947039 14.94 L 20.023026 14.97 L 20.033882 14.97 L 20.044737 14.955 L 20.012171 14.895 Z M 19.96875 14.895 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 20.044737 14.985 C 20.044737 14.97 20.044737 14.955 20.044737 14.955 C 20.033882 14.94 20.023026 14.94 20.012171 14.955 C 20.001316 14.955 20.001316 14.97 20.012171 14.985 C 20.023026 14.985 20.033882 14.985 20.044737 14.985 Z M 20.044737 14.985 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 20.164145 15.135 C 20.164145 15.135 20.196711 15.135 20.229276 15.135 C 20.250987 15.135 20.272697 15.165 20.272697 15.165 C 20.272697 15.165 20.283553 15.12 20.250987 15.09 C 20.218421 15.075 20.175 15.105 20.175 15.105 C 20.175 15.105 20.164145 15.12 20.164145 15.135 Z M 20.164145 15.135 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 20.109868 15.06 L 20.088158 15.105 L 20.153289 15.135 L 20.175 15.135 L 20.164145 15.06 Z M 20.109868 15.06 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill-rule: nonzero;
            fill: rgb(78.431373%, 70.196078%, 18.431373%);
            fill-opacity: 1;
            stroke-width: 0.0218;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 20.175 15.135 C 20.175 15.135 20.185855 15.12 20.175 15.105 C 20.175 15.105 20.164145 15.105 20.153289 15.105 C 20.142434 15.12 20.131579 15.135 20.142434 15.135 C 20.153289 15.15 20.164145 15.15 20.175 15.135 Z M 20.175 15.135 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
        <path
          style="
            fill: none;
            stroke-width: 0.0437;
            stroke-linecap: butt;
            stroke-linejoin: miter;
            stroke: rgb(0%, 0%, 0%);
            stroke-opacity: 1;
            stroke-miterlimit: 4;
          "
          d="M 17.135526 18.885 L 21.358224 18.885 L 21.358224 14.22 L 17.135526 14.22 Z M 17.135526 18.885 "
          transform="matrix(0.359848,0,0,0.260417,0.0681818,0)"
        ></path>
      </g>
    </svg>
    <svg
      v-if="props.icon == 'en'"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 60 30"
    >
      <clipPath id="s">
        <path d="M0,0 v30 h60 v-30 z"></path>
      </clipPath>
      <clipPath id="t">
        <path d="M30,15 h30 v15 z v15 h-30 z h-30 v-15 z v-15 h30 z"></path>
      </clipPath>
      <g clip-path="url(#s)">
        <path d="M0,0 v30 h60 v-30 z" fill="#012169"></path>
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" stroke-width="6"></path>
        <path
          d="M0,0 L60,30 M60,0 L0,30"
          clip-path="url(#t)"
          stroke="#C8102E"
          stroke-width="4"
        ></path>
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" stroke-width="10"></path>
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" stroke-width="6"></path>
      </g>
    </svg>
    <svg
      v-if="props.icon == 'ro'"
      width="20"
      height="17"
      fill="currentColor"
      viewBox="0 0 3 2"
    >
      <rect width="3" height="2" x="0" y="0" fill="#002B7F"></rect>
      <rect width="2" height="2" x="1" y="0" fill="#FCD116"></rect>
      <rect width="1" height="2" x="2" y="0" fill="#CE1126"></rect>
    </svg>
    <svg
      v-if="props.icon == 'ico-linkedin'"
      width="10"
      height="10"
      fill="currentColor"
      viewBox="0 0 11.3 10.9"
    >
      <path
        d="M1.4 2.5C.5 2.5 0 2 0 1.3 0 .5.5 0 1.4 0c.8 0 1.4.5 1.4 1.3-.1.7-.6 1.2-1.4 1.2zM0 3.6h2.7v7.3H0zM4 6.1c0-1 0-1.8-.1-2.5h2.3l.1.9c.3-.4 1-1.1 2.2-1.1 1.7 0 2.6 1.2 2.6 3.2v4.3H8.6v-4c0-.8-.3-1.3-.9-1.3-.5 0-.8.4-.9.6-.1.1-.1.4-.1.5v4.2H4V6.1z"
      />
    </svg>
    <svg
      v-if="props.icon == 'scan'"
      width="20"
      height="20"
      fill="currentColor"
      viewBox="0 0 16 16"
    >
      <path
        d="M1.5 1a.5.5 0 0 0-.5.5v3a.5.5 0 0 1-1 0v-3A1.5 1.5 0 0 1 1.5 0h3a.5.5 0 0 1 0 1h-3zM11 .5a.5.5 0 0 1 .5-.5h3A1.5 1.5 0 0 1 16 1.5v3a.5.5 0 0 1-1 0v-3a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 1-.5-.5zM.5 11a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 1 0 1h-3A1.5 1.5 0 0 1 0 14.5v-3a.5.5 0 0 1 .5-.5zm15 0a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5zM3 4.5a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7zm2 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-7zm3 0a.5.5 0 0 1 1 0v7a.5.5 0 0 1-1 0v-7z"
      />
    </svg>
    <svg
      v-if="props.icon == 'name'"
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 13H8V12.5208C8 12.276 7.93403 12.0491 7.80208 11.8403C7.67014 11.6314 7.48611 11.4694 7.25 11.3542C6.97222 11.2431 6.69097 11.1562 6.40625 11.0938C6.12153 11.0312 5.81944 11 5.5 11C5.18056 11 4.87847 11.0312 4.59375 11.0938C4.30903 11.1562 4.02778 11.2463 3.75 11.364C3.51389 11.4685 3.32986 11.6259 3.19792 11.836C3.06597 12.0462 3 12.2745 3 12.5208V13ZM10.75 12H12.25C12.4583 12 12.6354 11.9271 12.7812 11.7812C12.9271 11.6354 13 11.4583 13 11.25C13 11.0417 12.9271 10.8646 12.7812 10.7188C12.6354 10.5729 12.4583 10.5 12.25 10.5H10.75C10.5417 10.5 10.3646 10.5729 10.2188 10.7188C10.0729 10.8646 10 11.0417 10 11.25C10 11.4583 10.0729 11.6354 10.2188 11.7812C10.3646 11.9271 10.5417 12 10.75 12ZM5.5 10.5C5.84722 10.5 6.14236 10.3785 6.38542 10.1354C6.62847 9.89236 6.75 9.59722 6.75 9.25C6.75 8.90278 6.62847 8.60764 6.38542 8.36458C6.14236 8.12153 5.84722 8 5.5 8C5.15278 8 4.85764 8.12153 4.61458 8.36458C4.37153 8.60764 4.25 8.90278 4.25 9.25C4.25 9.59722 4.37153 9.89236 4.61458 10.1354C4.85764 10.3785 5.15278 10.5 5.5 10.5ZM10.75 9.5H12.25C12.4583 9.5 12.6354 9.42708 12.7812 9.28125C12.9271 9.13542 13 8.95833 13 8.75C13 8.54167 12.9271 8.36458 12.7812 8.21875C12.6354 8.07292 12.4583 8 12.25 8H10.75C10.5417 8 10.3646 8.07292 10.2188 8.21875C10.0729 8.36458 10 8.54167 10 8.75C10 8.95833 10.0729 9.13542 10.2188 9.28125C10.3646 9.42708 10.5417 9.5 10.75 9.5ZM1.5 16C1.0875 16 0.734375 15.8531 0.440625 15.5594C0.146875 15.2656 0 14.9125 0 14.5V5.5C0 5.0875 0.146875 4.73438 0.440625 4.44063C0.734375 4.14688 1.0875 4 1.5 4H6V1.5C6 1.0875 6.14688 0.734376 6.44063 0.440626C6.73438 0.146876 7.0875 0 7.5 0H8.5C8.9125 0 9.26562 0.146876 9.55937 0.440626C9.85312 0.734376 10 1.0875 10 1.5V4H14.5C14.9125 4 15.2656 4.14688 15.5594 4.44063C15.8531 4.73438 16 5.0875 16 5.5V14.5C16 14.9125 15.8531 15.2656 15.5594 15.5594C15.2656 15.8531 14.9125 16 14.5 16H1.5ZM1.5 14.5H14.5V5.5H10C10 5.91667 9.85312 6.27083 9.55937 6.5625C9.26562 6.85417 8.9125 7 8.5 7H7.5C7.0875 7 6.73438 6.85312 6.44063 6.55937C6.14688 6.26562 6 5.9125 6 5.5H1.5V14.5ZM7.5 5.5H8.5V1.5H7.5V5.5Z"
      />
    </svg>
    <svg
      v-if="props.icon == 'experience'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_120_4406"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" />
      </mask>
      <g mask="url(#mask0_120_4406)">
        <path
          d="M3.16634 16.4167C2.98579 16.2361 2.89551 16.0174 2.89551 15.7604C2.89551 15.5035 2.9844 15.2861 3.1622 15.1083L8.12659 10.1439C8.20865 10.0619 8.30523 9.99653 8.41634 9.94792C8.52745 9.89931 8.63856 9.875 8.74967 9.875C8.86079 9.875 8.9719 9.89931 9.08301 9.94792C9.19412 9.99653 9.29074 10.0619 9.37286 10.144L12.083 12.8542L17.333 6.95833C17.4997 6.76389 17.7045 6.66319 17.9476 6.65625C18.1906 6.64931 18.4025 6.73534 18.583 6.91435C18.7485 7.07845 18.835 7.27611 18.8426 7.50733C18.8501 7.73856 18.7782 7.93701 18.6269 8.10271L12.7068 14.7925C12.6243 14.8892 12.524 14.9618 12.4059 15.0104C12.2879 15.059 12.1733 15.0833 12.0622 15.0833C11.9511 15.0833 11.84 15.0625 11.7288 15.0208C11.6177 14.9792 11.5136 14.9097 11.4163 14.8125L8.74967 12.1458L4.45315 16.4424C4.27583 16.6197 4.06217 16.7049 3.81217 16.6979C3.56217 16.691 3.3469 16.5972 3.16634 16.4167ZM3.43197 11.2708C3.35211 11.2708 3.27398 11.25 3.19759 11.2083C3.1212 11.1667 3.06217 11.1042 3.02051 11.0208L2.60384 10.125L1.70801 9.70833C1.62467 9.66667 1.56217 9.6059 1.52051 9.52604C1.47884 9.44618 1.45801 9.36632 1.45801 9.28646C1.45801 9.2066 1.47884 9.12847 1.52051 9.05208C1.56217 8.97569 1.62467 8.91667 1.70801 8.875L2.60384 8.45833L3.02051 7.5625C3.06217 7.47917 3.12294 7.41319 3.2028 7.36458C3.28266 7.31597 3.36252 7.29167 3.44238 7.29167C3.52224 7.29167 3.60037 7.31597 3.67676 7.36458C3.75315 7.41319 3.81217 7.47917 3.85384 7.5625L4.27051 8.45833L5.16634 8.875C5.3469 8.95833 5.43717 9.09722 5.43717 9.29167C5.43717 9.48611 5.3469 9.625 5.16634 9.70833L4.27051 10.125L3.85384 11.0208C3.81217 11.1042 3.75141 11.1667 3.67155 11.2083C3.59169 11.25 3.51183 11.2708 3.43197 11.2708ZM12.4945 9.60417C12.4146 9.60417 12.3365 9.58333 12.2601 9.54167C12.1837 9.5 12.1247 9.4375 12.083 9.35417L11.6663 8.45833L10.7705 8.04167C10.6872 8 10.6247 7.93924 10.583 7.85938C10.5413 7.77951 10.5205 7.69965 10.5205 7.61979C10.5205 7.53993 10.5413 7.46181 10.583 7.38542C10.6247 7.30903 10.6872 7.25 10.7705 7.20833L11.6663 6.79167L12.083 5.89583C12.1247 5.8125 12.1854 5.74653 12.2653 5.69792C12.3452 5.64931 12.425 5.625 12.5049 5.625C12.5847 5.625 12.6629 5.64931 12.7393 5.69792C12.8156 5.74653 12.8747 5.8125 12.9163 5.89583L13.333 6.79167L14.2288 7.20833C14.3122 7.25 14.3747 7.31076 14.4163 7.39062C14.458 7.47049 14.4788 7.55035 14.4788 7.63021C14.4788 7.71007 14.458 7.78819 14.4163 7.86458C14.3747 7.94097 14.3122 8 14.2288 8.04167L13.333 8.45833L12.9163 9.35417C12.8747 9.4375 12.8139 9.5 12.734 9.54167C12.6542 9.58333 12.5743 9.60417 12.4945 9.60417ZM7.1403 7.10417C7.06044 7.10417 6.98231 7.07986 6.90592 7.03125C6.82954 6.98264 6.77051 6.91667 6.72884 6.83333L6.18717 5.66667L5.02051 5.125C4.93717 5.08333 4.8712 5.02257 4.82259 4.94271C4.77398 4.86285 4.74967 4.78299 4.74967 4.70312C4.74967 4.62326 4.77398 4.54514 4.82259 4.46875C4.8712 4.39236 4.93717 4.33309 5.02051 4.29094L6.18717 3.7429L6.72884 2.5625C6.77051 2.46528 6.83127 2.39931 6.91113 2.36458C6.99099 2.32986 7.07086 2.3125 7.15072 2.3125C7.23058 2.3125 7.3087 2.32986 7.38509 2.36458C7.46148 2.39931 7.52051 2.46528 7.56217 2.5625L8.10384 3.7429L9.27051 4.29094C9.35384 4.33309 9.41981 4.3941 9.46842 4.47396C9.51704 4.55382 9.54134 4.63368 9.54134 4.71354C9.54134 4.7934 9.51704 4.87153 9.46842 4.94792C9.41981 5.02431 9.35384 5.08333 9.27051 5.125L8.10384 5.66667L7.56217 6.83333C7.52051 6.91667 7.45974 6.98264 7.37988 7.03125C7.30002 7.07986 7.22016 7.10417 7.1403 7.10417Z"
        />
      </g>
    </svg>

    <svg
      v-if="props.icon == 'role'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_120_4412"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" />
      </mask>
      <g mask="url(#mask0_120_4412)">
        <path
          d="M3.5 17C3.0875 17 2.73438 16.8531 2.44063 16.5594C2.14688 16.2656 2 15.9125 2 15.5V6.5C2 6.0875 2.14688 5.73438 2.44063 5.44062C2.73438 5.14687 3.0875 5 3.5 5H7V3.49558C7 3.08186 7.14706 2.72917 7.44117 2.4375C7.73528 2.14583 8.08883 2 8.50183 2H11.5055C11.9185 2 12.2708 2.14687 12.5625 2.44062C12.8542 2.73437 13 3.0875 13 3.5V5H16.5C16.9125 5 17.2656 5.14687 17.5594 5.44062C17.8531 5.73438 18 6.0875 18 6.5V15.5C18 15.9125 17.8531 16.2656 17.5594 16.5594C17.2656 16.8531 16.9125 17 16.5 17H3.5ZM3.5 15.5H16.5V6.5H3.5V15.5ZM8.5 5H11.5V3.5H8.5V5Z"
        />
      </g>
    </svg>

    <svg
      v-if="props.icon == 'location'"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_120_4400"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" />
      </mask>
      <g mask="url(#mask0_120_4400)">
        <path
          d="M10.0023 10.0417C10.4728 10.0417 10.8747 9.87413 11.208 9.53907C11.5413 9.20402 11.708 8.80124 11.708 8.33074C11.708 7.86024 11.5405 7.45832 11.2054 7.12499C10.8704 6.79166 10.4676 6.62499 9.99709 6.62499C9.52659 6.62499 9.12467 6.79252 8.79134 7.12757C8.45801 7.46263 8.29134 7.86541 8.29134 8.33591C8.29134 8.80641 8.45887 9.20832 8.79392 9.54166C9.12898 9.87499 9.53176 10.0417 10.0023 10.0417ZM9.99967 16C11.6802 14.4583 12.9198 13.0646 13.7184 11.8188C14.517 10.5729 14.9163 9.46668 14.9163 8.49999C14.9163 6.9861 14.4441 5.76041 13.4997 4.82291C12.5552 3.88541 11.3886 3.41666 9.99967 3.41666C8.61079 3.41666 7.44412 3.88541 6.49967 4.82291C5.55523 5.76041 5.08301 6.9861 5.08301 8.49999C5.08301 9.46668 5.48231 10.5729 6.28092 11.8188C7.07954 13.0646 8.31912 14.4583 9.99967 16ZM9.99447 17.9792C9.87294 17.9792 9.75662 17.9583 9.64551 17.9167C9.5344 17.875 9.43023 17.8194 9.33301 17.75C7.30523 15.9444 5.79829 14.2847 4.81217 12.7708C3.82606 11.2569 3.33301 9.83062 3.33301 8.49186C3.33301 6.40006 3.99967 4.73957 5.33301 3.51041C6.66634 2.28124 8.2219 1.66666 9.99967 1.66666C11.7775 1.66666 13.333 2.28124 14.6663 3.51041C15.9997 4.73957 16.6663 6.40006 16.6663 8.49186C16.6663 9.83062 16.1733 11.2569 15.1872 12.7708C14.2011 14.2847 12.6941 15.9442 10.6663 17.7492C10.583 17.8192 10.4806 17.875 10.359 17.9167C10.2375 17.9583 10.116 17.9792 9.99447 17.9792Z"
        />
      </g>
    </svg>

    <svg
        v-if="props.icon == 'user'"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
    >
      <mask
          id="mask0_120_4400"
          style="mask-type: alpha"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="20"
          height="20"
      >
        <rect width="20" height="20" />
      </mask>
      <g mask="url(#mask0_120_4400)">
        <path
            d="M17.3 20.174v-2.13a4.363 4.363 0 00-1.194-3.013 3.988 3.988 0 00-2.881-1.248H5.076a3.988 3.988 0 00-2.881 1.248A4.363 4.363 0 001 18.044v2.13M13.224 5.26A4.079 4.079 0 119.15 1a4.171 4.171 0 014.074 4.26z"
        />
      </g>
    </svg>

  </div>
</template>

<script setup>
const props = defineProps({ icon: String });
</script>
